//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { url } from "inspector";
import { SnackbarMessage } from "../hooks";
import { IManageFilesDTO } from "../pages/IManageFiles/IManageFilesTypes";
import { AuthorizedApiBase } from "./authorized-api-base";
import { Offset } from "devextreme-react/autocomplete";

export enum Username {
  ADMIN = "RSMTaxPortalAdmin",
}
export enum Descriptions {
  IMANAGE_FILES = "iManage",
  TAXPORTAL_FOLDERS = "Tax Portal",
  CS_FOLDERS = "Corporate Sight",
}
export enum TimeUnit {
  NULL = "NULL",
  SECONDS = "Seconds",
  MINUTES = "Minutes",
  HOURS = "Hours",
}
export enum ScheduleStatus {
  STOPPED = "Stopped",
  SCHEDULED = "Scheduled",
}
export enum BooleanValue {
  YES = "YES",
  NO = "NO",
}
export enum FormatDate {
  AC = "MMM Do YY, h:mm:ss A",
  HQ = "MM/DD/YYYY HH:mm",
  NAME = "MM-DD-YYYY_hh_mm_ss",
  DD = "MM/DD/YYYY",
  MDY = "MMM Do YY",
}
export enum SelectName {
  INFORMATION_REQUEST = "Information Request ISheet",
  PROJECT_STATUS = "Project Status ISheet",
  DOCUMENT_METADATA = "Document Metadata ISheet",
  UPDATE_FILES_LOCATION = "Update files location",
  UPDATE_FILES_METADATA = "Update files metadata",
  DOWNLOAD_FILES = "Download accepted files",
  DOWNLOAD_ATTACHMENT_IR = "Download Attachment IR",
  UPLOAD_FILES = "Upload accepted files to iManage",
  UPLOAD_ATTACHMENT_IR = "Upload Attachment IR",
  UPDATE_IR_METADATA = "Update IR metadata",
  SEND_FILES_TO_DUO = "Send files to DUO",
  LEGAL_ENTITIES = "Legal Entities ISheet",
  UPDATE_AND_MOVE_FILES = "Handling exceptions",
  SYNC_MDM = "Sync MDM Entity & Consent",
  SYNC_MDM_PROJECT = "Sync MDM Projects",
  SYNC_MDM_PHASE = "Sync MDM Phases",
  THIRD_PARTY_ORG = "Third-party Organizations",
  POPULATE_MEMBERFIRM_DROPDOWN = "Member Firm Organizations",
  CONTROVERSY_TRACKER = "Controversy Tracker",
  UPDATE_K1TRACKER_ENTITY_DROPDOWN = "K1 Tracker Isheet",
  UPDATE_DELIVERABLES_ENTITY_DROPDOWN = "Deliverables Isheet",
  USER_SYNC = "Synchronize Users",
  DELETED_RECORD_SYNC = "Synchronize Deleted Records",
  LEGACY_RECORD_SYNC = "Synchronize Legacy Records",
}
export enum SelectCustomPermission {
  CUSTOM_GROUPS = "Update Custom Groups",
  PROJECT_STATUS = "Update PS Views",
  INFORMATION_REQUEST = "Update IR Views",
  UPDATE_IRVIEW_PERMISSIONS = "Update IR View Permissions",
  UPDATE_PSVIEW_PERMISSIONS = "Update PS View Permissions",
  UPDATE_FOLDER_PERMISSIONS = "Update Folder Permissions",
  EMAIL_FAILURE = "Send Email for failures",
  K1_TRACKER = "Update K1 Tracker",
  UPDATE_DELIVERABLES = "Update Deliverables",
  UPDATE_K1_TRACKER_PERMISSIONS = "Update K1 Tracker View Permissions",
  UPDATE_DELIVERABLES_PERMISSIONS = "Update Deliverables View Permissions",
}
export enum SelectCustomPermissionIsheetType {
  ProjectStatus = "Project Status",
  InformationRequest = "Information Request List",
  K1Tracker = "K-1 Tracker",
  Deliverables = "Deliverables",
}

export enum RunOnUpdatedSiteSelect {
  YES = "YES",
  NO = "NO",
  SELECT = "SELECT",
}

export interface GetUserRolloverDTO {
  id: number;
  executionDate: string;
  userId: number;
  userName?: string;
  status: string;
  statusDetails: string;
  processType: string;
  rollOverType: string;
  processTrackId: number;
  isActive?: boolean;
  created?: string;
  createdBy?: string;
  lastModified?: string;
  lastModifiedBy?: string;
  hqSiteId?: number;
  mdmClientId?: number;
  rollOverStatus?: "INPROGRESS" | "COMPLETED" | "FAILED" | string;
  rollOverStatusMessage?: string;
  rolloverRequestedDate?: string | null;
  scheduledDate?: string | null;
  canceledDate?: string | null;
  canceledBy?: string | null;
  firstNotificationSent?: string | null;
  secondNotificationSent?: string | null;
  canceledNotificationSent?: string | null;
  retryRollOver?: boolean;
  cancelRollOver?: boolean;
  taxYear?: number;
  newTaxYear?: number;
  appName?: string;
  secondNotificationScheduledDate?: string | null;
  firstNotificationDate?: string | null;
  sendCancellationEmail?: boolean | null;
  isFSTemplate?: boolean | null;
}
export interface FilesInspection {
  [key: string]: MoveIManageFiles[];
}
export interface MoveIManageFiles {
  targetParentFolderId?: string;
  sourceDocumentId: string;
  sourceContainerId: string;
  fileName: string;
  nameWithoutExtension?: string;
  extension?: string;
  documentId: number;
  newFileName?: string;
  isDuplicated?: boolean;
  overWrite?: boolean;
  isEdited?: boolean;
  isOmitted?: boolean;
  requestId?: number;
  downloaded?: boolean;
}

export interface MoveHighQFiles {
  siteId?: number;
  mdmClientId?: number;
  hQFileId?: string;
  fileName?: string;
  workspaceName?: string;
  hQItemId?: string;
  hQEntityID?: number;
  hQParentFolderId?: string;
  hQParentFolderPath?: string;
  hQEntityName?: string;
  destinationFolderPath?: string;
  isEdited?: boolean;
  isOmitted?: boolean;
}
export interface MoveHighQFilesDTO {
  siteId?: number;
  mdmClientId?: number;
  hqRootFolderId?: string;
  workspaceName?: string;
  userEmail?: string;
  data?: MoveHighQFiles[];
}
export interface MoveHighQFilesResponse {
  message: SnackbarMessage;
  success: boolean;
  filesForInspection: MoveHighQFiles[];
}

export interface HQSiteDetailsDTO {
  id?: number | undefined;
  sitename?: string | undefined;
  createddate?: string | undefined;
  sitedescription?: string | undefined;
  upgradeDate?: string | undefined;
}

export interface GetScheduleFiles {
  id: number;
  appName: string;
  displayName: string;
  frequencyValue: number;
  frequencyType: string;
  status: string;
  jobType: string;
  startExecution: string;
  lastExecutionStatus: string;
  lastExecutionDateTime: string;
  nextExecutionDateTime: string;
  typeNumber: number;
  runOnUpdatedSiteSelect: string | null;
  scheduleConfig: string | null;
  scheduleConfigMessage: ScheduleConfigMessage | null;
  siteServiceApi: string | null;
}

export interface ScheduleConfigMessage {
  siteIds: number[] | null;
  iSheetName: string | null;
}

export interface MoveFilesDTO {
  data: MoveIManageFiles[];
  siteId: number;
  userEmail: string | undefined;
}
export interface MoveIManageFilesResponse {
  message: SnackbarMessage;
  success: boolean;
  filesForInspection: MoveIManageFiles[];
}

export interface PowerBIRefreshResponse {
  isSuccess?: boolean;
  message?: string;
}

export interface HQSiteChangesDTO {
  siteId: number;
  status?: string;
  upgradeDate?: string;
  siteChanges: HQSiteChangesDetailDTO[];
}
export interface HQSiteChangesDetailDTO {
  comparisonId: string;
  module: string | null;
  change: string | null;
  object: string | null;
  status: string | null;
  upgradeWarning: string[];
  changesDetail: ChangesDetail[];
  modifiedDetail: ChangesDetail[];
  siteId?: number;
}
export interface GetSiteSettingsDTO {
  id: string | number;
  setting: string;
  description: string;
  value: string;
  actionDisplayName: string;
  actionUrl: string;
}

export interface BulkSitesChangeDetailsDTO {
  created: string;
  createdBy: string;
  id: string;
  isActive: boolean;
  lastModified: string | null;
  lastModifiedBy: string | null;
  processDescription: string | null;
  retry: number | 0;
  status: string | null;
  statusMessage: string | null;
}

export class TaxPortalServiceClient extends AuthorizedApiBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  // Globant API Implementation - Start

  taxPortal_GetDirectories(type: Descriptions, siteId: number, isSource: any): Promise<IManageFilesDTO> {
    let url_ = `${this.baseUrl}/api/`;
    url_ += (() => {
      if (type === Descriptions.TAXPORTAL_FOLDERS) return "foldersBySiteId?";
      return "";
    })();
    if (siteId === undefined || siteId === null)
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    else url_ += "siteId=" + encodeURIComponent("" + siteId);
    if (type === Descriptions.TAXPORTAL_FOLDERS) url_ += "&isSource=" + encodeURIComponent("" + isSource);
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetDirectories(_response);
      });
  }

  taxPortal_GetAppName(siteId: number): Promise<string> {
    let url_ = `${this.baseUrl}/api/GetAppNameBySiteId?`;

    if (siteId === undefined || siteId === null) {
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    } else {
      url_ += "siteId=" + encodeURIComponent("" + siteId);
    }

    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        if (_response.status === 404) {
          throw new Error("Application name not found for the given site ID.");
        } else if (!_response.ok) {
          throw new Error("An unexpected server error occurred.");
        }
        return _response.text(); // since the API returns plain string
      });
  }

  protected processTaxPortal_GetDirectories(response: Response): Promise<IManageFilesDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as IManageFilesDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<IManageFilesDTO>(null as any);
  }
  taxPortal_GetIManageFiles(
    siteId: number,
    clientId?: string,
    workspaceId?: string,
    isSource?: boolean
  ): Promise<DocumentTreeDTO> {
    let url_ = `${this.baseUrl}/api/GetHQTreeStructureByWorkspaceID?`;
    if (siteId === undefined || siteId === null)
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    else url_ += "siteId=" + encodeURIComponent("" + siteId);

    if (clientId) url_ += "&clientId=" + encodeURIComponent("" + clientId);
    if (workspaceId) url_ += "&workspaceId=" + encodeURIComponent("" + workspaceId);
    url_ += "&isSource=" + encodeURIComponent("" + isSource);
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetIManageFiles(_response);
      });
  }
  protected processTaxPortal_GetIManageFiles(response: Response): Promise<DocumentTreeDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null as any;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DocumentTreeResponseDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<DocumentTreeDTO>(null as any);
  }

  taxPortal_UpdateScheduleLogsForUser(
    id: number,
    updateJob: GetScheduleFiles,
    userName: string
  ): Promise<GetScheduleFiles> {
    let url_ = this.baseUrl + `/api/scheduledJobs/${id}`;
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined and cannot be null.");
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(updateJob);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        userName: userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UpdateScheduleLogsForUser(_response);
      });
  }
  protected processTaxPortal_UpdateScheduleLogsForUser(response: Response): Promise<GetScheduleFiles> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetScheduleFiles);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetScheduleFiles>(null as any);
  }
  taxPortal_GetAllSchedules(): Promise<GetScheduleFiles[]> {
    let url_ = this.baseUrl + "/api/scheduledJobs";
    url_ = url_.replace(/[?&]$/, "");
    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };
    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetAllSchedules(_response);
      });
  }
  protected processTaxPortal_GetAllSchedules(response: Response): Promise<GetScheduleFiles[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetScheduleFiles[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetScheduleFiles[]>(null as any);
  }
  taxPortal_MoveTaxPortalFilesToIManage(
    files: MoveHighQFilesDTO | undefined,
    signal: AbortSignal
  ): Promise<MoveHighQFilesResponse> {
    let url_ = `${this.baseUrl}/api/MoveDocumentsFromHighQToImanage`;
    const content_ = JSON.stringify(files);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      signal,
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal__MoveTaxPortalFilesToIManage(_response);
      });
  }
  protected processTaxPortal__MoveTaxPortalFilesToIManage(response: Response): Promise<MoveHighQFilesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MoveHighQFilesResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        const response = JSON.parse(_responseText);
        return throwException("Conflicts with files.", status, response, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MoveHighQFilesResponse>(null as any);
  }

  taxPortal_MoveIManageFilesToTaxPortal(
    files: MoveFilesDTO | undefined,
    iManageSource: boolean,
    signal: AbortSignal
  ): Promise<MoveIManageFilesResponse> {
    let url_ = `${this.baseUrl}/api/`;
    url_ += (() => {
      if (iManageSource === true) return "MoveDocumentsFromImanageToHighQ";
    })();
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(files);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      signal,
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_MoveIManageFilesToTaxPortal(_response);
      });
  }
  protected processTaxPortal_MoveIManageFilesToTaxPortal(response: Response): Promise<MoveIManageFilesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MoveIManageFilesResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        const response = JSON.parse(_responseText);
        return throwException("Conflicts with files.", status, response, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MoveIManageFilesResponse>(null as any);
  }

  /**
   * Service to update the Permissions
   * @param permissionChange (optional)
   */
  templateSiteComparison_TemplateSitesSheetUpdatePermission(
    templateId: number,
    siteId: number,
    templateIsheetId: number,
    siteIsheetId: number,
    permissionChange: string | undefined,
    signal?: AbortSignal
  ): Promise<HQISheetPermissionsResponse[]> {
    let url_ =
      this.baseUrl + "/api/TemplateSitesSheetUpdatePermission/{templateId}/{siteId}/{templateIsheetId}/{siteIsheetId}?";
    if (templateId === undefined || templateId === null) throw new Error("The parameter 'templateId' must be defined.");
    url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (templateIsheetId === undefined || templateIsheetId === null)
      throw new Error("The parameter 'templateIsheetId' must be defined.");
    url_ = url_.replace("{templateIsheetId}", encodeURIComponent("" + templateIsheetId));
    if (siteIsheetId === undefined || siteIsheetId === null)
      throw new Error("The parameter 'siteIsheetId' must be defined.");
    url_ = url_.replace("{siteIsheetId}", encodeURIComponent("" + siteIsheetId));
    if (permissionChange === null) throw new Error("The parameter 'permissionChange' cannot be null.");
    else if (permissionChange !== undefined)
      url_ += "permissionChange=" + encodeURIComponent("" + permissionChange) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTemplateSiteComparison_TemplateSitesSheetUpdatePermission(_response);
      });
  }

  protected processTemplateSiteComparison_TemplateSitesSheetUpdatePermission(
    response: Response
  ): Promise<HQISheetPermissionsResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as HQISheetPermissionsResponse[]);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException("A server side error occurred.", status, _responseText, _headers);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQISheetPermissionsResponse[]>(null as any);
  }
  
  protected processTemplateSiteComparison_GetHQTemplateSitesComparisonAll(
    response: Response
  ): Promise<TemplateSiteComparisonResultDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as TemplateSiteComparisonResultDTO[]);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "Request was success but no comparison result was found",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Badrequest", status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<TemplateSiteComparisonResultDTO[]>(null as any);
  }

  protected processTemplateSiteComparison_ApplyHQTemplateSitesComparisonChanges(
    response: Response
  ): Promise<ChangesAppliedResultResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ChangesAppliedResultResponse[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Badrequest", status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ChangesAppliedResultResponse[]>(null as any);
  }

  cEM_GetClients(signal?: AbortSignal): Promise<CEMClientDTO[]> {
    let url_ = this.baseUrl + "/api/clients";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_GetClients(_response);
      });
  }

  protected processCEM_GetClients(response: Response): Promise<CEMClientDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CEMClientDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CEMClientDTO[]>(null as any);
  }

  cEM_GetCEMClientsByAppId(signal?: AbortSignal): Promise<CEMClientDTO[]> {
    let url_ = this.baseUrl + "/api/clientsByAppId";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_GetCEMClientsByAppId(_response);
      });
  }

  protected processCEM_GetCEMClientsByAppId(response: Response): Promise<CEMClientDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CEMClientDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CEMClientDTO[]>(null as any);
  }

  /**
   * Get Clients from CEM by SearchTerm
   * @param searchTerm (optional)
   */
  cEM_CEMSearchClients(searchTerm: string | undefined, signal?: AbortSignal): Promise<CEMClientDTO[]> {
    let url_ = this.baseUrl + "/api/clients/search?";
    if (searchTerm === null) throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined) url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_CEMSearchClients(_response);
      });
  }

  protected processCEM_CEMSearchClients(response: Response): Promise<CEMClientDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CEMClientDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CEMClientDTO[]>(null as any);
  }

  cEM_UpdateSitesForUser(user: CEMUserDetails, signal?: AbortSignal): Promise<CEMUserRecord> {
    let url_ = this.baseUrl + "/api/user/updateSites";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(user);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_UpdateSitesForUser(_response);
      });
  }

  protected processCEM_UpdateSitesForUser(response: Response): Promise<CEMUserRecord> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CEMUserRecord);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CEMUserRecord>(null as any);
  }

  cEM_checkRealTime(requestBody: CEMRTAssigmentDTO, signal?: AbortSignal): Promise<Task> {
    let url_ = this.baseUrl + "/api/checkRealTime";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestBody);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_checkRealTime(_response);
      });
  }

  protected processCEM_checkRealTime(response: Response): Promise<Task> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Task);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<Task>(null as any);
  }

  cEM_SyncCEMClient(clientId: number, signal?: AbortSignal): Promise<Task> {
    let url_ = this.baseUrl + "/api/SyncCEMClient/{ClientId}";
    if (clientId === undefined || clientId === null) throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{ClientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_SyncCEMClient(_response);
      });
  }

  cEM_SyncCEMRoles(signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/SyncCEMRoles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_SyncCEMRoles(_response);
      });
  }

  protected processCEM_SyncCEMRoles(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  protected processCEM_SyncCEMClient(response: Response): Promise<Task> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Task);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<Task>(null as any);
  }

  cEM_AddUsersToL2SupportInCEM(
    roleName: string | undefined,
    mdmClientId: number | undefined,
    siteId: number | undefined,
    emails: string[],
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/AddUsersToL2SupportInCEM?";
    if (roleName === null) throw new Error("The parameter 'roleName' cannot be null.");
    else if (roleName !== undefined) url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
    if (mdmClientId === null) throw new Error("The parameter 'mdmClientId' cannot be null.");
    else if (mdmClientId !== undefined) url_ += "mdmClientId=" + encodeURIComponent("" + mdmClientId) + "&";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(emails);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_AddUsersToL2SupportInCEM(_response);
      });
  }

  protected processCEM_AddUsersToL2SupportInCEM(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  cEM_RemoveUsersToL2SupportInCEM(
    mdmClientId: number | undefined,
    siteId: number | undefined,
    roleName: string | undefined,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/RemoveUsersToL2SupportInCEM?";
    if (mdmClientId === null) throw new Error("The parameter 'mdmClientId' cannot be null.");
    else if (mdmClientId !== undefined) url_ += "mdmClientId=" + encodeURIComponent("" + mdmClientId) + "&";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
    if (roleName === null) throw new Error("The parameter 'roleName' cannot be null.");
    else if (roleName !== undefined) url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCEM_RemoveUsersToL2SupportInCEM(_response);
      });
  }

  protected processCEM_RemoveUsersToL2SupportInCEM(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Syncronize Site Controversy Tracker Users with Central Controversy Tracker Users
   * @return Template and Sites iSheet comparison Result
   */
  centralControversyTracker_SyncControversyTrackerUsers(
    siteId: number,
    signal?: AbortSignal
  ): Promise<MessageResultDTO> {
    let url_ = this.baseUrl + "/SyncControversyTrackerUsers/{siteId}";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCentralControversyTracker_SyncControversyTrackerUsers(_response);
      });
  }

  protected processCentralControversyTracker_SyncControversyTrackerUsers(
    response: Response
  ): Promise<MessageResultDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "Request was success but no comparison result was found",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Badrequest", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MessageResultDTO>(null as any);
  }

  /**
   * Get Central Controversy Tracker Records based on site controversy tracker users.
   * @return Central Controversy Tracker Records
   */
  centralControversyTracker_GetCentralControversyTrackerRecords(
    user: string,
    signal?: AbortSignal
  ): Promise<GetCentralControversyTrackerDetailsDTO> {
    let url_ = this.baseUrl + "/GetCentralControversyTrackerRecords/{user}";
    if (user === undefined || user === null) throw new Error("The parameter 'user' must be defined.");
    url_ = url_.replace("{user}", encodeURIComponent("" + user));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCentralControversyTracker_GetCentralControversyTrackerRecords(_response);
      });
  }

  protected processCentralControversyTracker_GetCentralControversyTrackerRecords(
    response: Response
  ): Promise<GetCentralControversyTrackerDetailsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GetCentralControversyTrackerDetailsDTO);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "Request was success but no >Central Controversy Tracker Records was found for user",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Badrequest", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetCentralControversyTrackerDetailsDTO>(null as any);
  }
  highQ_GetConsentedTaxYear(siteId: number | undefined, signal?: AbortSignal): Promise<number> {
    let url_ = this.baseUrl + "/api/GetConsentedTaxYear";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteId);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetConsentedTaxYear(_response);
      });
  }

  protected processHighQ_GetConsentedTaxYear(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * Adds a new central controversy tracker record based on the provided web hook request.
   * @param instanceId (optional)
   * @param instanceBaseUrl (optional)
   * @param timeZone (optional)
   * @param siteId (optional)
   * @param workflowVersion (optional)
   * @param workflowId (optional)
   * @param ruleId (optional)
   * @param ruleExecutionTimestamp (optional)
   * @param author (optional)
   * @param triggerDetail_v1_moduleAlias (optional)
   * @param triggerDetail_v1_operation (optional)
   * @param triggerDetail_v1_contentDetail_contentId (optional)
   * @param triggerDetail_v1_contentDetail_isheetId (optional)
   * @param triggerDetail_v1_contentDetail_columnIds (optional)
   * @return A message indicating the result of the operation, such as success or a specific error.
   */
  centralControversyTracker_AddToCentralControversyTracker(
    instanceId: string | null | undefined,
    instanceBaseUrl: string | null | undefined,
    timeZone: string | null | undefined,
    siteId: number | undefined,
    workflowVersion: string | null | undefined,
    workflowId: number | undefined,
    ruleId: number | undefined,
    ruleExecutionTimestamp: number | undefined,
    author: number | undefined,
    triggerDetail_v1_moduleAlias: string | null | undefined,
    triggerDetail_v1_operation: string | null | undefined,
    triggerDetail_v1_contentDetail_contentId: number | undefined,
    triggerDetail_v1_contentDetail_isheetId: number | undefined,
    triggerDetail_v1_contentDetail_columnIds: number[] | undefined,
    signal?: AbortSignal
  ): Promise<MessageResultDTO> {
    let url_ = this.baseUrl + "/AddToCentralControversyTracker?";
    if (instanceId !== undefined && instanceId !== null)
      url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
    if (instanceBaseUrl !== undefined && instanceBaseUrl !== null)
      url_ += "instanceBaseUrl=" + encodeURIComponent("" + instanceBaseUrl) + "&";
    if (timeZone !== undefined && timeZone !== null) url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (workflowVersion !== undefined && workflowVersion !== null)
      url_ += "workflowVersion=" + encodeURIComponent("" + workflowVersion) + "&";
    if (workflowId === null) throw new Error("The parameter 'workflowId' cannot be null.");
    else if (workflowId !== undefined) url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
    if (ruleId === null) throw new Error("The parameter 'ruleId' cannot be null.");
    else if (ruleId !== undefined) url_ += "ruleId=" + encodeURIComponent("" + ruleId) + "&";
    if (ruleExecutionTimestamp === null) throw new Error("The parameter 'ruleExecutionTimestamp' cannot be null.");
    else if (ruleExecutionTimestamp !== undefined)
      url_ += "ruleExecutionTimestamp=" + encodeURIComponent("" + ruleExecutionTimestamp) + "&";
    if (author === null) throw new Error("The parameter 'author' cannot be null.");
    else if (author !== undefined) url_ += "author=" + encodeURIComponent("" + author) + "&";
    if (triggerDetail_v1_moduleAlias !== undefined && triggerDetail_v1_moduleAlias !== null)
      url_ += "triggerDetail.v1.moduleAlias=" + encodeURIComponent("" + triggerDetail_v1_moduleAlias) + "&";
    if (triggerDetail_v1_operation !== undefined && triggerDetail_v1_operation !== null)
      url_ += "triggerDetail.v1.operation=" + encodeURIComponent("" + triggerDetail_v1_operation) + "&";
    if (triggerDetail_v1_contentDetail_contentId === null)
      throw new Error("The parameter 'triggerDetail_v1_contentDetail_contentId' cannot be null.");
    else if (triggerDetail_v1_contentDetail_contentId !== undefined)
      url_ +=
        "triggerDetail.v1.contentDetail.contentId=" +
        encodeURIComponent("" + triggerDetail_v1_contentDetail_contentId) +
        "&";
    if (triggerDetail_v1_contentDetail_isheetId === null)
      throw new Error("The parameter 'triggerDetail_v1_contentDetail_isheetId' cannot be null.");
    else if (triggerDetail_v1_contentDetail_isheetId !== undefined)
      url_ +=
        "triggerDetail.v1.contentDetail.isheetId=" +
        encodeURIComponent("" + triggerDetail_v1_contentDetail_isheetId) +
        "&";
    if (triggerDetail_v1_contentDetail_columnIds === null)
      throw new Error("The parameter 'triggerDetail_v1_contentDetail_columnIds' cannot be null.");
    else if (triggerDetail_v1_contentDetail_columnIds !== undefined)
      triggerDetail_v1_contentDetail_columnIds &&
        triggerDetail_v1_contentDetail_columnIds.forEach((item) => {
          url_ += "triggerDetail.v1.contentDetail.columnIds=" + encodeURIComponent("" + item) + "&";
        });
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCentralControversyTracker_AddToCentralControversyTracker(_response);
      });
  }

  protected processCentralControversyTracker_AddToCentralControversyTracker(
    response: Response
  ): Promise<MessageResultDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO);
        return throwException("A server side error occurred.", status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MessageResultDTO>(null as any);
  }

  /**
   * Update the central controversy tracker record details based on the provided web hook request.
   * @param instanceId (optional)
   * @param instanceBaseUrl (optional)
   * @param timeZone (optional)
   * @param siteId (optional)
   * @param workflowVersion (optional)
   * @param workflowId (optional)
   * @param ruleId (optional)
   * @param ruleExecutionTimestamp (optional)
   * @param author (optional)
   * @param triggerDetail_v1_moduleAlias (optional)
   * @param triggerDetail_v1_operation (optional)
   * @param triggerDetail_v1_contentDetail_contentId (optional)
   * @param triggerDetail_v1_contentDetail_isheetId (optional)
   * @param triggerDetail_v1_contentDetail_columnIds (optional)
   * @return A message indicating the result of the operation, such as success or a specific error.
   */
  centralControversyTracker_UpdateCentralControversyTracker(
    instanceId: string | null | undefined,
    instanceBaseUrl: string | null | undefined,
    timeZone: string | null | undefined,
    siteId: number | undefined,
    workflowVersion: string | null | undefined,
    workflowId: number | undefined,
    ruleId: number | undefined,
    ruleExecutionTimestamp: number | undefined,
    author: number | undefined,
    triggerDetail_v1_moduleAlias: string | null | undefined,
    triggerDetail_v1_operation: string | null | undefined,
    triggerDetail_v1_contentDetail_contentId: number | undefined,
    triggerDetail_v1_contentDetail_isheetId: number | undefined,
    triggerDetail_v1_contentDetail_columnIds: number[] | undefined,
    signal?: AbortSignal
  ): Promise<MessageResultDTO> {
    let url_ = this.baseUrl + "/UpdateCentralControversyTracker?";
    if (instanceId !== undefined && instanceId !== null)
      url_ += "instanceId=" + encodeURIComponent("" + instanceId) + "&";
    if (instanceBaseUrl !== undefined && instanceBaseUrl !== null)
      url_ += "instanceBaseUrl=" + encodeURIComponent("" + instanceBaseUrl) + "&";
    if (timeZone !== undefined && timeZone !== null) url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (workflowVersion !== undefined && workflowVersion !== null)
      url_ += "workflowVersion=" + encodeURIComponent("" + workflowVersion) + "&";
    if (workflowId === null) throw new Error("The parameter 'workflowId' cannot be null.");
    else if (workflowId !== undefined) url_ += "workflowId=" + encodeURIComponent("" + workflowId) + "&";
    if (ruleId === null) throw new Error("The parameter 'ruleId' cannot be null.");
    else if (ruleId !== undefined) url_ += "ruleId=" + encodeURIComponent("" + ruleId) + "&";
    if (ruleExecutionTimestamp === null) throw new Error("The parameter 'ruleExecutionTimestamp' cannot be null.");
    else if (ruleExecutionTimestamp !== undefined)
      url_ += "ruleExecutionTimestamp=" + encodeURIComponent("" + ruleExecutionTimestamp) + "&";
    if (author === null) throw new Error("The parameter 'author' cannot be null.");
    else if (author !== undefined) url_ += "author=" + encodeURIComponent("" + author) + "&";
    if (triggerDetail_v1_moduleAlias !== undefined && triggerDetail_v1_moduleAlias !== null)
      url_ += "triggerDetail.v1.moduleAlias=" + encodeURIComponent("" + triggerDetail_v1_moduleAlias) + "&";
    if (triggerDetail_v1_operation !== undefined && triggerDetail_v1_operation !== null)
      url_ += "triggerDetail.v1.operation=" + encodeURIComponent("" + triggerDetail_v1_operation) + "&";
    if (triggerDetail_v1_contentDetail_contentId === null)
      throw new Error("The parameter 'triggerDetail_v1_contentDetail_contentId' cannot be null.");
    else if (triggerDetail_v1_contentDetail_contentId !== undefined)
      url_ +=
        "triggerDetail.v1.contentDetail.contentId=" +
        encodeURIComponent("" + triggerDetail_v1_contentDetail_contentId) +
        "&";
    if (triggerDetail_v1_contentDetail_isheetId === null)
      throw new Error("The parameter 'triggerDetail_v1_contentDetail_isheetId' cannot be null.");
    else if (triggerDetail_v1_contentDetail_isheetId !== undefined)
      url_ +=
        "triggerDetail.v1.contentDetail.isheetId=" +
        encodeURIComponent("" + triggerDetail_v1_contentDetail_isheetId) +
        "&";
    if (triggerDetail_v1_contentDetail_columnIds === null)
      throw new Error("The parameter 'triggerDetail_v1_contentDetail_columnIds' cannot be null.");
    else if (triggerDetail_v1_contentDetail_columnIds !== undefined)
      triggerDetail_v1_contentDetail_columnIds &&
        triggerDetail_v1_contentDetail_columnIds.forEach((item) => {
          url_ += "triggerDetail.v1.contentDetail.columnIds=" + encodeURIComponent("" + item) + "&";
        });
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "PUT",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCentralControversyTracker_UpdateCentralControversyTracker(_response);
      });
  }

  protected processCentralControversyTracker_UpdateCentralControversyTracker(
    response: Response
  ): Promise<MessageResultDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO);
        return result201;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO);
        return throwException("A server side error occurred.", status, _responseText, _headers, result500);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MessageResultDTO>(null as any);
  }

  functionScheduler_GetListOfScheduleJobs(signal?: AbortSignal): Promise<GetSchedulesDTO[]> {
    let url_ = this.baseUrl + "/api/scheduledJobs";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processFunctionScheduler_GetListOfScheduleJobs(_response);
      });
  }

  protected processFunctionScheduler_GetListOfScheduleJobs(response: Response): Promise<GetSchedulesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetSchedulesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetSchedulesDTO[]>(null as any);
  }

  functionScheduler_UpdateJobScheduler(
    id: number,
    userName: string | undefined,
    job: FunctionSchedulerDTO,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/scheduledJobs/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(job);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        userName: userName !== undefined && userName !== null ? "" + userName : "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processFunctionScheduler_UpdateJobScheduler(_response);
      });
  }

  protected processFunctionScheduler_UpdateJobScheduler(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  highQ_GetHQTaskTemplate(signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/taskTemplate";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetHQTaskTemplate(_response);
      });
  }

  protected processHighQ_GetHQTaskTemplate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  highQ_GetHQSiteDetails(message: SiteCreationMessage, signal?: AbortSignal): Promise<HQSiteDetailsDTO[]> {
    let url_ = this.baseUrl + "/api/siteDetails";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(message);

    let options_: RequestInit = {
      body: content_,
      method: "GET",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetHQSiteDetails(_response);
      });
  }

  protected processHighQ_GetHQSiteDetails(response: Response): Promise<HQSiteDetailsDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQSiteDetailsDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQSiteDetailsDTO[]>(null as any);
  }

  highQ_GetSiteFromTrackSearch(
    status: string | null | undefined,
    searchTerm: string | null | undefined,
    appName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<GetAllSitesFromTrackResponse> {
    let url_ = this.baseUrl + "/api/siteTrackSearch?";
    if (status !== undefined && status !== null) url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (searchTerm !== undefined && searchTerm !== null)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetSiteFromTrackSearch(_response);
      });
  }

  protected processHighQ_GetSiteFromTrackSearch(response: Response): Promise<GetAllSitesFromTrackResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSitesFromTrackResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSitesFromTrackResponse>(null as any);
  }

  highQ_HQGetChoices(isheetId: number | undefined, signal?: AbortSignal): Promise<HQGetChoicesDTO[]> {
    let url_ = this.baseUrl + "/api/getChoices?";
    if (isheetId === null) throw new Error("The parameter 'isheetId' cannot be null.");
    else if (isheetId !== undefined) url_ += "isheetId=" + encodeURIComponent("" + isheetId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_HQGetChoices(_response);
      });
  }

  protected processHighQ_HQGetChoices(response: Response): Promise<HQGetChoicesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQGetChoicesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQGetChoicesDTO[]>(null as any);
  }

  highQ_GetHQProgressKey(progressKey: string | undefined, signal?: AbortSignal): Promise<string[]> {
    let url_ = this.baseUrl + "/api/progressKey?";
    if (progressKey === null) throw new Error("The parameter 'progressKey' cannot be null.");
    else if (progressKey !== undefined) url_ += "progressKey=" + encodeURIComponent("" + progressKey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetHQProgressKey(_response);
      });
  }

  protected processHighQ_GetHQProgressKey(response: Response): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string[]>(null as any);
  }

  highQ_GetProjectStatusItems(siteId: number | undefined, signal?: AbortSignal): Promise<HQAssignmentDTO> {
    let url_ = this.baseUrl + "/api/GetProjectStatusItems?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetProjectStatusItems(_response);
      });
  }

  protected processHighQ_GetProjectStatusItems(response: Response): Promise<HQAssignmentDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQAssignmentDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQAssignmentDTO>(null as any);
  }

  highQ_GetInformationRequestItems(siteId: number | undefined, signal?: AbortSignal): Promise<HQAssignmentDTO> {
    let url_ = this.baseUrl + "/api/GetInformationRequestItems?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetInformationRequestItems(_response);
      });
  }

  protected processHighQ_GetInformationRequestItems(response: Response): Promise<HQAssignmentDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQAssignmentDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQAssignmentDTO>(null as any);
  }

  highQ_GetUserSites(email: string | null | undefined, signal?: AbortSignal): Promise<ExternalUserSite[]> {
    let url_ = this.baseUrl + "/api/GetUserSites?";
    if (email !== undefined && email !== null) url_ += "email=" + encodeURIComponent("" + email) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetUserSites(_response);
      });
  }

  protected processHighQ_GetUserSites(response: Response): Promise<ExternalUserSite[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ExternalUserSite[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ExternalUserSite[]>(null as any);
  }

  highQ_PopulateIRISheet(
    siteId: number | undefined,
    clientId: number | undefined,
    signal?: AbortSignal
  ): Promise<HQAddItems[]> {
    let url_ = this.baseUrl + "/api/PopulateIRISheet?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (clientId === null) throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined) url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_PopulateIRISheet(_response);
      });
  }

  protected processHighQ_PopulateIRISheet(response: Response): Promise<HQAddItems[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQAddItems[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQAddItems[]>(null as any);
  }

  highQ_CheckRecordExistsIR(
    siteId: number | undefined,
    selectedEntities: MDMSelectedLegalEntityDTO[],
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/client/checkRecordExistsIR?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(selectedEntities);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_CheckRecordExistsIR(_response);
      });
  }

  protected processHighQ_CheckRecordExistsIR(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  highQ_HQOrganizationFromDb(
    offset: number | undefined,
    limit: number | undefined,
    orgType: string | undefined,
    signal?: AbortSignal
  ): Promise<GetAllOrgResponse> {
    let url_ = this.baseUrl + "/api/HQOrganizationFromDb?";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (orgType === null) throw new Error("The parameter 'orgType' cannot be null.");
    else if (orgType !== undefined) url_ += "orgType=" + encodeURIComponent("" + orgType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_HQOrganizationFromDb(_response);
      });
  }

  protected processHighQ_HQOrganizationFromDb(response: Response): Promise<GetAllOrgResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllOrgResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllOrgResponse>(null as any);
  }

  highQ_CreateThirdPartyOrganization(
    orgName: string | undefined,
    orgType: string | undefined,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/CreateThirdPartyOrganization?";
    if (orgName === null) throw new Error("The parameter 'orgName' cannot be null.");
    else if (orgName !== undefined) url_ += "orgName=" + encodeURIComponent("" + orgName) + "&";
    if (orgType === null) throw new Error("The parameter 'orgType' cannot be null.");
    else if (orgType !== undefined) url_ += "orgType=" + encodeURIComponent("" + orgType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_CreateThirdPartyOrganization(_response);
      });
  }

  protected processHighQ_CreateThirdPartyOrganization(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  highQ_UpdateThirdPartyOrganization(
    orgName: string | undefined,
    orgId: string | undefined,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/UpdateThirdPartyOrganization?";
    if (orgName === null) throw new Error("The parameter 'orgName' cannot be null.");
    else if (orgName !== undefined) url_ += "orgName=" + encodeURIComponent("" + orgName) + "&";
    if (orgId === null) throw new Error("The parameter 'orgId' cannot be null.");
    else if (orgId !== undefined) url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_UpdateThirdPartyOrganization(_response);
      });
  }

  protected processHighQ_UpdateThirdPartyOrganization(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  highQ_GetSiteMetricsInfo(
    appName: string | undefined,
    siteRequests: string | undefined,
    offset: number | undefined,
    limit: number | undefined,
    signal?: AbortSignal
  ): Promise<GetAllSiteMetricResponse> {
    let url_ = this.baseUrl + "/api/GetSiteMetricsInfo?";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (siteRequests === null) throw new Error("The parameter 'siteRequests' cannot be null.");
    else if (siteRequests !== undefined) url_ += "siteRequests=" + encodeURIComponent("" + siteRequests) + "&";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetSiteMetricsInfo(_response);
      });
  }

  protected processHighQ_GetSiteMetricsInfo(response: Response): Promise<GetAllSiteMetricResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSiteMetricResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSiteMetricResponse>(null as any);
  }

  highQ_GetSiteMetricsInfoSearch(
    appName: string | undefined,
    siteRequests: string | undefined,
    searchTerm: string | null | undefined,
    signal?: AbortSignal
  ): Promise<GetAllSiteMetricResponse> {
    let url_ = this.baseUrl + "/api/GetSiteMetricsInfoSearch?";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (siteRequests === null) throw new Error("The parameter 'siteRequests' cannot be null.");
    else if (siteRequests !== undefined) url_ += "siteRequests=" + encodeURIComponent("" + siteRequests) + "&";
    if (searchTerm !== undefined && searchTerm !== null)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetSiteMetricsInfoSearch(_response);
      });
  }

  protected processHighQ_GetSiteMetricsInfoSearch(response: Response): Promise<GetAllSiteMetricResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllSiteMetricResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllSiteMetricResponse>(null as any);
  }

  highQ_ExportToExcelForSiteMetrics(
    appName: string | undefined,
    sites: GetAllSiteMetricsDTO[],
    signal?: AbortSignal
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/ExportToExcelForSiteMetrics?";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(sites);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_ExportToExcelForSiteMetrics(_response);
      });
  }

  protected processHighQ_ExportToExcelForSiteMetrics(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  mDM_ExportToExcelForLegalEntities(
    siteId: number | undefined,
    mdmClientId: number | undefined,
    appName: string | undefined,
    signal?: AbortSignal
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/ExportToExcelForMDMLegalEntities?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (mdmClientId === null) throw new Error("The parameter 'clientId' cannot be null.");
    else if (mdmClientId !== undefined) url_ += "mdmClientId=" + encodeURIComponent("" + mdmClientId) + "&";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processmDM_ExportToExcelForLegalEntities(_response);
      });
  }

  protected processmDM_ExportToExcelForLegalEntities(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  highQ_ExportToExcelForManageSite(
    appName: string | undefined,
    status: string | null | undefined,
    signal?: AbortSignal
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/ExportToExcelForManageSite?";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (status !== undefined && status !== null) url_ += "status=" + encodeURIComponent("" + status) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_ExportToExcelForManageSite(_response);
      });
  }

  protected processHighQ_ExportToExcelForManageSite(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  highQ_CustomPermissions(
    siteId: number | undefined,
    clientId: number | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/CustomPermissions?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (clientId === null) throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined) url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_CustomPermissions(_response);
      });
  }

  protected processHighQ_CustomPermissions(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  highQ_UpdateViewPermissions(messages: ServiceMessage[], signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/UpdateViewPermissions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_UpdateViewPermissions(_response);
      });
  }

  protected processHighQ_UpdateViewPermissions(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  highQ_SendEmailCustomPermissions(messages: ServiceMessage[], signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/SendEmailCustomPermissions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_SendEmailCustomPermissions(_response);
      });
  }

  protected processHighQ_SendEmailCustomPermissions(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  highQ_RemoveThirdPartyOrginisation(
    orgId: string | undefined,
    orgName: string | undefined,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/RemoveThirdPartyOrginisation?";
    if (orgId === null) throw new Error("The parameter 'orgId' cannot be null.");
    else if (orgId !== undefined) url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
    if (orgName === null) throw new Error("The parameter 'orgName' cannot be null.");
    else if (orgName !== undefined) url_ += "OrgName=" + encodeURIComponent("" + orgName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_RemoveThirdPartyOrginisation(_response);
      });
  }

  protected processHighQ_RemoveThirdPartyOrginisation(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  highQ_GetViewName(siteId: number | undefined, contentId: number | undefined, signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/GetViewName?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (contentId === null) throw new Error("The parameter 'contentId' cannot be null.");
    else if (contentId !== undefined) url_ += "contentId=" + encodeURIComponent("" + contentId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_GetViewName(_response);
      });
  }

  protected processHighQ_GetViewName(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Download Files from SiteId
   * @param userName (optional)
   * @param itemSyncTrackId (optional)
   * @param isUpdateAndMoveFilesProcess (optional)
   */
  hQFile_DownloadFilesFromSiteId(
    hqSiteId: number,
    userName: string | undefined,
    itemSyncTrackId: number | undefined,
    isUpdateAndMoveFilesProcess: boolean | undefined,
    signal?: AbortSignal
  ): Promise<CEMHQClientMappingDTO[]> {
    let url_ = this.baseUrl + "/api/DownloadFile/{hqSiteId}?";
    if (hqSiteId === undefined || hqSiteId === null) throw new Error("The parameter 'hqSiteId' must be defined.");
    url_ = url_.replace("{hqSiteId}", encodeURIComponent("" + hqSiteId));
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    if (itemSyncTrackId === null) throw new Error("The parameter 'itemSyncTrackId' cannot be null.");
    else if (itemSyncTrackId !== undefined) url_ += "itemSyncTrackId=" + encodeURIComponent("" + itemSyncTrackId) + "&";
    if (isUpdateAndMoveFilesProcess === null)
      throw new Error("The parameter 'isUpdateAndMoveFilesProcess' cannot be null.");
    else if (isUpdateAndMoveFilesProcess !== undefined)
      url_ += "isUpdateAndMoveFilesProcess=" + encodeURIComponent("" + isUpdateAndMoveFilesProcess) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQFile_DownloadFilesFromSiteId(_response);
      });
  }

  protected processHQFile_DownloadFilesFromSiteId(response: Response): Promise<CEMHQClientMappingDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CEMHQClientMappingDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CEMHQClientMappingDTO[]>(null as any);
  }

  hQFile_UploadFilesFromSiteId(
    hqSiteId: number,
    userName: string | undefined,
    appName: string | null | undefined,
    itemSyncTracksIdUpload: number | null | undefined,
    signal?: AbortSignal
  ): Promise<MessageResultDTO[]> {
    let url_ = this.baseUrl + "/api/UploadFile/{hqSiteId}?";
    if (hqSiteId === undefined || hqSiteId === null) throw new Error("The parameter 'hqSiteId' must be defined.");
    url_ = url_.replace("{hqSiteId}", encodeURIComponent("" + hqSiteId));
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    if (itemSyncTracksIdUpload !== undefined && itemSyncTracksIdUpload !== null)
      url_ += "ItemSyncTracksIdUpload=" + encodeURIComponent("" + itemSyncTracksIdUpload) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQFile_UploadFilesFromSiteId(_response);
      });
  }

  protected processHQFile_UploadFilesFromSiteId(response: Response): Promise<MessageResultDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MessageResultDTO[]>(null as any);
  }

  hQFile_UpdateFileMetadataFromSiteId(
    hqSiteId: number,
    isUpdateAndMoveFilesProcess: boolean | undefined,
    signal?: AbortSignal
  ): Promise<MessageResultDTO[]> {
    let url_ = this.baseUrl + "/api/UpdateFileMetadata/{hqSiteId}?";
    if (hqSiteId === undefined || hqSiteId === null) throw new Error("The parameter 'hqSiteId' must be defined.");
    url_ = url_.replace("{hqSiteId}", encodeURIComponent("" + hqSiteId));
    if (isUpdateAndMoveFilesProcess === null)
      throw new Error("The parameter 'isUpdateAndMoveFilesProcess' cannot be null.");
    else if (isUpdateAndMoveFilesProcess !== undefined)
      url_ += "isUpdateAndMoveFilesProcess=" + encodeURIComponent("" + isUpdateAndMoveFilesProcess) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQFile_UpdateFileMetadataFromSiteId(_response);
      });
  }

  protected processHQFile_UpdateFileMetadataFromSiteId(response: Response): Promise<MessageResultDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MessageResultDTO[]>(null as any);
  }

  hQFile_MoveFilesFromSiteId(
    hqSiteId: number,
    isUpdateAndMoveFilesProcess: boolean | undefined,
    signal?: AbortSignal
  ): Promise<MessageResultDTO[]> {
    let url_ = this.baseUrl + "/api/MoveFile/{hqSiteId}?";
    if (hqSiteId === undefined || hqSiteId === null) throw new Error("The parameter 'hqSiteId' must be defined.");
    url_ = url_.replace("{hqSiteId}", encodeURIComponent("" + hqSiteId));
    if (isUpdateAndMoveFilesProcess === null)
      throw new Error("The parameter 'isUpdateAndMoveFilesProcess' cannot be null.");
    else if (isUpdateAndMoveFilesProcess !== undefined)
      url_ += "isUpdateAndMoveFilesProcess=" + encodeURIComponent("" + isUpdateAndMoveFilesProcess) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQFile_MoveFilesFromSiteId(_response);
      });
  }

  protected processHQFile_MoveFilesFromSiteId(response: Response): Promise<MessageResultDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MessageResultDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MessageResultDTO[]>(null as any);
  }

  hQFolder_GetHQTreeStructureByWorkspaceID(
    siteId: number | undefined,
    clientId: string | undefined,
    workspaceId: string | null | undefined,
    isSource: boolean | undefined,
    signal?: AbortSignal
  ): Promise<DocumentTreeDTO[]> {
    let url_ = this.baseUrl + "/api/GetHQTreeStructureByWorkspaceID?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (clientId === null) throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined) url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
    if (workspaceId !== undefined && workspaceId !== null)
      url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
    if (isSource === null) throw new Error("The parameter 'isSource' cannot be null.");
    else if (isSource !== undefined) url_ += "isSource=" + encodeURIComponent("" + isSource) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQFolder_GetHQTreeStructureByWorkspaceID(_response);
      });
  }

  protected processHQFolder_GetHQTreeStructureByWorkspaceID(response: Response): Promise<DocumentTreeDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DocumentTreeDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<DocumentTreeDTO[]>(null as any);
  }

  /**
   * Process to move documents from imanage to hihgq.
   * @param body Body (MoveFromImanageToHighQRequest) payload.
   * @return All the files were moved sucessfully
   */
  hQFolder_MoveDocumentsFromImanageToHighQ(
    body: MoveFromImanageToHighQRequest,
    signal?: AbortSignal
  ): Promise<MoveFromImanageToHighQResponse[]> {
    let url_ = this.baseUrl + "/api/MoveDocumentsFromImanageToHighQ";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQFolder_MoveDocumentsFromImanageToHighQ(_response);
      });
  }

  protected processHQFolder_MoveDocumentsFromImanageToHighQ(
    response: Response
  ): Promise<MoveFromImanageToHighQResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as MoveFromImanageToHighQResponse[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Badrequest", status, _responseText, _headers, result400);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        let result401: any = null;
        result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("Unauthorized", status, _responseText, _headers, result401);
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null;
        result409 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as MoveFromImanageToHighQResponse);
        return throwException(
          "The process found duplicated files. check MoveFromImanageToHighQRequestObject.IsDuplicated when is true",
          status,
          _responseText,
          _headers,
          result409
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MoveFromImanageToHighQResponse[]>(null as any);
  }

  hQFolder_RefreshEntityImanage(
    siteId: number | undefined,
    isForceUpdate: boolean | undefined,
    target?: string | null,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/RefreshEntityImanage?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (target !== undefined && target !== null) url_ += "refreshTarget=" + encodeURIComponent("" + target) + "&";
    if (isForceUpdate === null) throw new Error("The parameter 'isForceUpdate' cannot be null.");
    else if (isForceUpdate !== undefined) url_ += "IsForceUpdate=" + encodeURIComponent("" + isForceUpdate) + "&";

    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQFolder_RefreshEntityImanage(_response);
      });
  }

  protected processHQFolder_RefreshEntityImanage(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  hQWebhook_HQWebhookAuth(signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWebhookAuth";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWebhookAuth(_response);
      });
  }

  protected processHQWebhook_HQWebhookAuth(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHAddFile(trigger: HQWHFile, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHAddFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHAddFile(_response);
      });
  }

  protected processHQWebhook_HQWHAddFile(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHUpdFile(trigger: HQWHFile, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHUpdFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHUpdFile(_response);
      });
  }

  protected processHQWebhook_HQWHUpdFile(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHIRISheet(trigger: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHIRISheet";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHIRISheet(_response);
      });
  }

  protected processHQWebhook_HQWHIRISheet(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHDocMetaDataISheet(trigger: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHDocMetaDataISheet";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHDocMetaDataISheet(_response);
      });
  }

  protected processHQWebhook_HQWHDocMetaDataISheet(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHDownloadFile(webHookRequest: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHDownloadFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(webHookRequest);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHDownloadFile(_response);
      });
  }

  protected processHQWebhook_HQWHDownloadFile(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHUploadFile(trigger: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHUploadFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHUploadFile(_response);
      });
  }

  protected processHQWebhook_HQWHUploadFile(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHPBIRefreshPS(trigger: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHPBIRefreshPS";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHPBIRefreshPS(_response);
      });
  }

  protected processHQWebhook_HQWHPBIRefreshPS(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHPBIRefreshIR(trigger: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHPBIRefreshIR";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHPBIRefreshIR(_response);
      });
  }

  protected processHQWebhook_HQWHPBIRefreshIR(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHDocMetaDataIRUpd(trigger: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHDocMetaDataIRUpd";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHDocMetaDataIRUpd(_response);
      });
  }

  protected processHQWebhook_HQWHDocMetaDataIRUpd(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_ExportToExcel(signal?: AbortSignal): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/ExportToExcel";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_ExportToExcel(_response);
      });
  }

  protected processHQWebhook_ExportToExcel(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  hQWebhook_HQWHUpdateDocumentMetaData(
    isUpdateAndMoveFilesProcess: boolean | undefined,
    webHookRequest: HQWHISheet,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHUpdateDocumentMetaData?";
    if (isUpdateAndMoveFilesProcess === null)
      throw new Error("The parameter 'isUpdateAndMoveFilesProcess' cannot be null.");
    else if (isUpdateAndMoveFilesProcess !== undefined)
      url_ += "isUpdateAndMoveFilesProcess=" + encodeURIComponent("" + isUpdateAndMoveFilesProcess) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(webHookRequest);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHUpdateDocumentMetaData(_response);
      });
  }

  protected processHQWebhook_HQWHUpdateDocumentMetaData(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHUpdateIRMetaData(
    isUpdateAndMoveFilesProcess: boolean | undefined,
    webHookRequest: HQWHISheet,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHUpdateIRMetaData?";
    if (isUpdateAndMoveFilesProcess === null)
      throw new Error("The parameter 'isUpdateAndMoveFilesProcess' cannot be null.");
    else if (isUpdateAndMoveFilesProcess !== undefined)
      url_ += "isUpdateAndMoveFilesProcess=" + encodeURIComponent("" + isUpdateAndMoveFilesProcess) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(webHookRequest);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHUpdateIRMetaData(_response);
      });
  }

  protected processHQWebhook_HQWHUpdateIRMetaData(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHSendFilesToDuo(webHookRequest: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHSendFilesToDuo";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(webHookRequest);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHSendFilesToDuo(_response);
      });
  }

  protected processHQWebhook_HQWHSendFilesToDuo(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  hQWebhook_HQWHFileMovement(trigger: HQWHISheet, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/HQWHFileMovement";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(trigger);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHQWebhook_HQWHFileMovement(_response);
      });
  }

  protected processHQWebhook_HQWHFileMovement(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  internalSite_AddUserGroupUsersToIs(
    siteId: number | undefined,
    userName: string | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/addUserGroupUsersToIs?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInternalSite_AddUserGroupUsersToIs(_response);
      });
  }

  protected processInternalSite_AddUserGroupUsersToIs(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * Get Legal Entities by Master Client
   * @param taxYear (optional)
   */
  mDM_GetMDMLegalEntities(
    mdmClientId: number,
    taxYear: number | null | undefined,
    signal?: AbortSignal
  ): Promise<MDMLegalEntityResponse> {
    let url_ = this.baseUrl + "/api/client/{mdmClientId}/legalEntities?";
    if (mdmClientId === undefined || mdmClientId === null)
      throw new Error("The parameter 'mdmClientId' must be defined.");
    url_ = url_.replace("{mdmClientId}", encodeURIComponent("" + mdmClientId));
    if (taxYear !== undefined && taxYear !== null) url_ += "taxYear=" + encodeURIComponent("" + taxYear) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_GetMDMLegalEntities(_response);
      });
  }

  protected processMDM_GetMDMLegalEntities(response: Response): Promise<MDMLegalEntityResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MDMLegalEntityResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MDMLegalEntityResponse>(null as any);
  }

  /**
   * Add Selected Legal Entities to Master Client
   */
  mDM_AddSelectedLegalEntities(entities: AddMDMSelectedLegalEntityDTO[], signal?: AbortSignal): Promise<number[]> {
    let url_ = this.baseUrl + "/api/client/addlegalEntities";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(entities);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_AddSelectedLegalEntities(_response);
      });
  }

  protected processMDM_AddSelectedLegalEntities(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(null as any);
  }

  mDM_EditSelectedLegalEntities(entities: MDMSelectedLegalEntityDTO[], signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/client/editlegalEntities";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(entities);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_EditSelectedLegalEntities(_response);
      });
  }

  protected processMDM_EditSelectedLegalEntities(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  mDM_SyncLegalEntities(
    mdmClientId: number,
    siteId: number | undefined,
    signal?: AbortSignal
  ): Promise<MDMLegalEntityDTO[]> {
    let url_ = this.baseUrl + "/api/client/{mdmClientId}/syncLegalEntities?";
    if (mdmClientId === undefined || mdmClientId === null)
      throw new Error("The parameter 'mdmClientId' must be defined.");
    url_ = url_.replace("{mdmClientId}", encodeURIComponent("" + mdmClientId));
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_SyncLegalEntities(_response);
      });
  }

  protected processMDM_SyncLegalEntities(response: Response): Promise<MDMLegalEntityDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as MDMLegalEntityDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<MDMLegalEntityDTO[]>(null as any);
  }

  mDM_PushOrg(siteId: number | undefined, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/pushOrg?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMDM_PushOrg(_response);
      });
  }

  protected processMDM_PushOrg(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  notification_Notify(
    userName: string | undefined,
    status: PortalStatusEnum | undefined,
    message: string | undefined,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/notify?";
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (message === null) throw new Error("The parameter 'message' cannot be null.");
    else if (message !== undefined) url_ += "message=" + encodeURIComponent("" + message) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processNotification_Notify(_response);
      });
  }

  protected processNotification_Notify(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  reports_GetPowerBIToken(biReport: PowerBIReport | undefined, signal?: AbortSignal): Promise<ADTokenDTO> {
    let url_ = this.baseUrl + "/api/GetPowerBIToken?";
    if (biReport === null) throw new Error("The parameter 'biReport' cannot be null.");
    else if (biReport !== undefined) url_ += "biReport=" + encodeURIComponent("" + biReport) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetPowerBIToken(_response);
      });
  }

  protected processReports_GetPowerBIToken(response: Response): Promise<ADTokenDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ADTokenDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ADTokenDTO>(null as any);
  }

  reports_GetEmbedReport(
    biReport: PowerBIReport | undefined,
    permissions: string[] | undefined,
    signal?: AbortSignal
  ): Promise<EmbeddedReportDTO> {
    let url_ = this.baseUrl + "/api/powerBI/report?";
    if (biReport === null) throw new Error("The parameter 'biReport' cannot be null.");
    else if (biReport !== undefined) url_ += "biReport=" + encodeURIComponent("" + biReport) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(permissions);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetEmbedReport(_response);
      });
  }

  protected processReports_GetEmbedReport(response: Response): Promise<EmbeddedReportDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmbeddedReportDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmbeddedReportDTO>(null as any);
  }

  reports_GetCustomReport(
    siteId: number,
    customReportId: number,
    roleAccessValues?: string[] | null,
    isSystemAdmin?: boolean,
    signal?: AbortSignal
  ): Promise<EmbeddedReportDTO> {
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    if (customReportId === undefined || customReportId === null)
      throw new Error("The parameter 'customReportId' must be defined.");

    let url_ = this.baseUrl + "/api/powerBI/GetCustomReport?";
    url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ += "CustomReportId=" + encodeURIComponent("" + customReportId) + "&";
    if (isSystemAdmin !== undefined && isSystemAdmin !== null)
      url_ += "isSystemAdmin=" + encodeURIComponent("" + isSystemAdmin) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(roleAccessValues || []);

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: content_,
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetCustomReport(_response);
      });
  }

  protected processReports_GetCustomReport(response: Response): Promise<EmbeddedReportDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmbeddedReportDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmbeddedReportDTO>(null as any);
  }

  reports_GetSitesBreakdown(biReport: PowerBIReport | undefined, signal?: AbortSignal): Promise<EmbeddedReportDTO> {
    let url_ = this.baseUrl + "/api/sitesBreakdown?";
    if (biReport === null) throw new Error("The parameter 'biReport' cannot be null.");
    else if (biReport !== undefined) url_ += "biReport=" + encodeURIComponent("" + biReport) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetSitesBreakdown(_response);
      });
  }

  protected processReports_GetSitesBreakdown(response: Response): Promise<EmbeddedReportDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmbeddedReportDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmbeddedReportDTO>(null as any);
  }

  reports_GetCSPowerBIRefreshURL(
    siteId: number,
    userName: string | undefined,
    powerBi: PowerBIReport | undefined,
    signal?: AbortSignal,
  ): Promise<PowerBIRefreshResponse> {
    let url_ = this.baseUrl + "/api/GetCSPowerBIRefreshURL?";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    else url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined and cannot be null.");
    else url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    if (powerBi === null) throw new Error("The parameter 'powerBi' cannot be null.");
    else if (powerBi === undefined) throw new Error("The parameter 'powerBi' must be defined.");
    else url_ += "powerBi=" + encodeURIComponent("" + powerBi) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetCSPowerBIRefreshURL(_response);
      });
  }

  protected processReports_GetCSPowerBIRefreshURL(response: Response): Promise<PowerBIRefreshResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PowerBIRefreshResponse);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<PowerBIRefreshResponse>(null as any);
  }

  reports_GetCustomPowerBiReportsBySiteId(siteId: number, signal?: AbortSignal): Promise<CustomPowerBiResponse[]> {
    if (siteId === undefined || siteId === null) {
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    }

    let url_ = this.baseUrl + `/api/${siteId}/GetCustomPowerBIReports`;
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetCustomPowerBiReportsBySiteId(_response);
      });
  }

  protected processReports_GetCustomPowerBiReportsBySiteId(response: Response): Promise<CustomPowerBiResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomPowerBiResponse[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomPowerBiResponse[]>(null as any);
  }

  reports_GetRolesForCustomPowerBI(siteId: number, signal?: AbortSignal): Promise<RolesDTO> {
    if (siteId === undefined || siteId === null) {
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    }

    let url_ = this.baseUrl + `/api/${siteId}/GetRolesForCustomPowerBI`;
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetRolesForCustomPowerBI(_response);
      });
  }

  protected processReports_GetRolesForCustomPowerBI(response: Response): Promise<RolesDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RolesDTO);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<RolesDTO>(null as any);
  }

  reports_GetCustomPowerBiReportById(id: number, signal?: AbortSignal): Promise<CustomPowerBiDTO> {
    if (id === undefined || id === null) {
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    }

    let url_ = this.baseUrl + "/api/custom-reports?id=" + encodeURIComponent("" + id);
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetCustomPowerBiReportById(_response);
      });
  }

  protected processReports_GetCustomPowerBiReportById(response: Response): Promise<CustomPowerBiDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomPowerBiDTO);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Custom PowerBI report not found.", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException("An error occurred while retrieving the report.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomPowerBiDTO>(null as any);
  }
  reports_RefreshCustomPowerBiDataSet(siteId: number, customPowerBIId: number, signal?: AbortSignal): Promise<boolean> {
    if (siteId === undefined || siteId === null) {
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    }
    if (customPowerBIId === undefined || customPowerBIId === null) {
      throw new Error("The parameter 'customPowerBIId' must be defined and cannot be null.");
    }

    let url_ = this.baseUrl + "/api/refresh-dataset/{siteId}/{customPowerBIId}";
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace("{customPowerBIId}", encodeURIComponent("" + customPowerBIId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_RefreshCustomPowerBiDataSet(_response);
      });
  }

  protected processReports_RefreshCustomPowerBiDataSet(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  reports_GetConsolidatedPowerBiReports(
    siteId: number,
    roleAccessValues?: string[] | undefined,
    signal?: AbortSignal
  ): Promise<ConsolidatedPowerBiReportDTO[]> {
    if (siteId === undefined || siteId === null) {
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    }

    const url_ = this.baseUrl + `/api/${encodeURIComponent("" + siteId)}/consolidated-powerbi-reports`;

    const content_ = JSON.stringify(roleAccessValues ?? []);

    const options_: RequestInit = {
      method: "POST",
      signal,
      body: content_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetConsolidatedPowerBiReports(_response);
      });
  }

  protected processReports_GetConsolidatedPowerBiReports(response: Response): Promise<ConsolidatedPowerBiReportDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ConsolidatedPowerBiReportDTO[]);
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "An error occurred while retrieving consolidated Power BI reports.",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ConsolidatedPowerBiReportDTO[]>(null as any);
  }

  reports_GetConsolidatedPowerBiEmbedUrl(
    reportType?: number | null,
    biReport?: PowerBIReport | null,
    signal?: AbortSignal
  ): Promise<EmbeddedReportDTO> {
    let url_ = this.baseUrl + "/api/powerBI/embed-url?";
    if (reportType === null) {
      /* Line omitted */
    } else if (reportType !== undefined) {
      url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
    }
    if (biReport === null) {
      /* Line omitted */
    } else if (biReport !== undefined) {
      url_ += "biReport=" + encodeURIComponent("" + biReport) + "&";
    }
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetConsolidatedPowerBiEmbedUrl(_response);
      });
  }

  protected processReports_GetConsolidatedPowerBiEmbedUrl(response: Response): Promise<EmbeddedReportDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmbeddedReportDTO);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Power BI report not found.", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        let result500: any = null;
        result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException(
          "An error occurred while retrieving the embedded report.",
          status,
          _responseText,
          _headers,
          result500
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmbeddedReportDTO>(null as any);
  }

  protected processReports_UpdateCustomPowerBiReport(response: Response): Promise<CustomPowerBiDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomPowerBiDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        // Backend returns NotFound(ex.Message) which might be plain string.
        return throwException("Not found.", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomPowerBiDTO>(null as any);
  }

  reports_UpdateCustomPowerBiReportForSite(
    siteId: number,
    id: number,
    requestDto: CustomPowerBiRequestDTO | undefined,
    signal?: AbortSignal
  ): Promise<CustomPowerBiDTO> {
    if (siteId === undefined || siteId === null) {
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    }
    if (id === undefined || id === null) {
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    }
    if (requestDto === null) {
      throw new Error("The parameter 'requestDto' cannot be null.");
    }

    let url_ = this.baseUrl + `/api/${siteId}/UpdateCustomPowerBIReports?`;
    url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestDto);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_UpdateCustomPowerBiReport(_response);
      });
  }

  reports_AddCustomPowerBIReports(
    siteId: number,
    requestDto: CustomPowerBiRequestDTO | undefined,
    signal?: AbortSignal
  ): Promise<CustomPowerBiDTO> {
    if (siteId === undefined || siteId === null) {
      throw new Error("The parameter 'siteId' must be defined and cannot be null.");
    }
    if (requestDto === null) {
      throw new Error("The parameter 'requestDto' cannot be null.");
    }

    let url_ = this.baseUrl + `/api/${siteId}/AddCustomPowerBIReports`;
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestDto);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_CreateCustomPowerBiReport(_response);
      });
  }

  reports_DeleteCustomPowerBiReport(id: number, signal?: AbortSignal): Promise<CustomPowerBiDeleteResponse> {
    if (id === undefined || id === null) {
      throw new Error("The parameter 'id' must be defined and cannot be null.");
    }

    let url_ = this.baseUrl + "/api/custom-reports/{id}";
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_DeleteCustomPowerBiReport(_response);
      });
  }

  protected processReports_DeleteCustomPowerBiReport(response: Response): Promise<CustomPowerBiDeleteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }

    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomPowerBiDeleteResponse);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CustomPowerBiDeleteResponse);
        return result404;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }

    return Promise.resolve<CustomPowerBiDeleteResponse>(null as any);
  }

  protected processReports_CreateCustomPowerBiReport(response: Response): Promise<CustomPowerBiDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 201) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomPowerBiDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 201 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomPowerBiDTO>(null as any);
  }

  reports_CheckAccessForExternalUser(
    userEmail: string | undefined,
    siteId: number | undefined,
    signal?: AbortSignal
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/CheckAccessForExternalUser?";
    if (userEmail === null) throw new Error("The parameter 'userEmail' cannot be null.");
    else if (userEmail !== undefined) url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_CheckAccessForExternalUser(_response);
      });
  }

  protected processReports_CheckAccessForExternalUser(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  reports_GetPlanningIdeasLink(siteId: number | null | undefined, signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/GetPlanningIdeasLink?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReports_GetPlanningIdeasLink(_response);
      });
  }

  protected processReports_GetPlanningIdeasLink(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  siteSetUp_SitesAPI(message: ServiceMessage, signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/sites/runSitesAPI";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(message);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSiteSetUp_SitesAPI(_response);
      });
  }

  protected processSiteSetUp_SitesAPI(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  siteSetUp_SiteSetUpStatus(siteId: number | undefined, signal?: AbortSignal): Promise<GetSiteInfoDTO> {
    let url_ = this.baseUrl + "/api/sites/siteSetUP/status?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSiteSetUp_SiteSetUpStatus(_response);
      });
  }

  protected processSiteSetUp_SiteSetUpStatus(response: Response): Promise<GetSiteInfoDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetSiteInfoDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetSiteInfoDTO>(null as any);
  }

  siteSetUp_AddTPSitesInTPAC(site: AddTPSitesDTO, signal?: AbortSignal): Promise<number[]> {
    let url_ = this.baseUrl + "/api/siteSetUp/addTPSitesInTPAC";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(site);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSiteSetUp_AddTPSitesInTPAC(_response);
      });
  }

  protected processSiteSetUp_AddTPSitesInTPAC(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as number[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(null as any);
  }

  siteSetUp_ExtractSiteDetails(siteId: number, signal?: AbortSignal): Promise<SiteExtractDetails> {
    let url_ = this.baseUrl + "/api/siteSetUp/extractSiteDetails/{siteId}";
    if (siteId === undefined || siteId === null) throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSiteSetUp_ExtractSiteDetails(_response);
      });
  }

  protected processSiteSetUp_ExtractSiteDetails(response: Response): Promise<SiteExtractDetails> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SiteExtractDetails);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SiteExtractDetails>(null as any);
  }

  taxPortal_GetHQTaskTemplate(signal?: AbortSignal): Promise<CEMHQClientMappingDTO[]> {
    let url_ = this.baseUrl + "/api/sites";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetHQTaskTemplate(_response);
      });
  }

  protected processTaxPortal_GetHQTaskTemplate(response: Response): Promise<CEMHQClientMappingDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CEMHQClientMappingDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CEMHQClientMappingDTO[]>(null as any);
  }

  taxPortal_ExportToExcelForAllSites(
    type: SyncTypeEnum | undefined,
    userName: string | null | undefined,
    appName: string | null | undefined,
    signal?: AbortSignal
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/ExportToExcelForAllSites?";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (userName !== undefined && userName !== null) url_ += "userName=" + encodeURIComponent("" + userName) + "&";
    if (appName !== undefined && appName !== null) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ExportToExcelForAllSites(_response);
      });
  }

  protected processTaxPortal_ExportToExcelForAllSites(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  taxPortal_CreateSites(messages: SiteCreationMessage[], signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/sites/createSites";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_CreateSites(_response);
      });
  }

  protected processTaxPortal_CreateSites(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxPortal_InsertTopic(messages: ServiceMessage[], signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/sites/insertTopic";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_InsertTopic(_response);
      });
  }

  protected processTaxPortal_InsertTopic(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }
  
  taxPortal_ProvideTESSAccess(message: ServiceMessage, signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/sites/provideTessAccess";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(message);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ProvideTESSAccess(_response);
      });
  }

  protected processTaxPortal_ProvideTESSAccess(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxPortal_ProvideAppAccess(messages: ServiceMessage[], signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/sites/provideAppAccess";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(messages);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ProvideAppAccess(_response);
      });
  }

  protected processTaxPortal_ProvideAppAccess(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxPortal_GetAllRoles(signal?: AbortSignal): Promise<GetAllRolesDTO[]> {
    let url_ = this.baseUrl + "/api/get-roles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetAllRoles(_response);
      });
  }

  protected processTaxPortal_GetAllRoles(response: Response): Promise<GetAllRolesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllRolesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllRolesDTO[]>(null as any);
  }

  taxPortal_ContentAdmin(siteId: number | undefined, signal?: AbortSignal): Promise<GetAllRolesDTO[]> {
    let url_ = this.baseUrl + "/api/content-admin?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ContentAdmin(_response);
      });
  }

  protected processTaxPortal_ContentAdmin(response: Response): Promise<GetAllRolesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllRolesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllRolesDTO[]>(null as any);
  }

  taxPortal_InternalUser(
    siteId: number | undefined,
    appName: string | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/internalUser?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (appName === null) throw new Error("The parameter 'appName' cannot be null.");
    else if (appName !== undefined) url_ += "appName=" + encodeURIComponent("" + appName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_InternalUser(_response);
      });
  }

  protected processTaxPortal_InternalUser(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_TESSIsheet(siteId: number | undefined, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/tESSIsheet?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_TESSIsheet(_response);
      });
  }

  protected processTaxPortal_TESSIsheet(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_ClientLevelAccess(
    siteId: number | undefined,
    roleId: string | undefined,
    roleName: string | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/clientLevelaccess?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (roleId === null) throw new Error("The parameter 'roleId' cannot be null.");
    else if (roleId !== undefined) url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
    if (roleName === null) throw new Error("The parameter 'roleName' cannot be null.");
    else if (roleName !== undefined) url_ += "roleName=" + encodeURIComponent("" + roleName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ClientLevelAccess(_response);
      });
  }

  protected processTaxPortal_ClientLevelAccess(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_PowerUser(siteId: number | null | undefined, signal?: AbortSignal): Promise<HQPowerUserRequestDTO[]> {
    let url_ = this.baseUrl + "/api/poweruser?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_PowerUser(_response);
      });
  }

  protected processTaxPortal_PowerUser(response: Response): Promise<HQPowerUserRequestDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as HQPowerUserRequestDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<HQPowerUserRequestDTO[]>(null as any);
  }

  taxPortal_ClearDistributedCache(key: string | undefined, signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/ClearDistributedCache?";
    if (key === null) throw new Error("The parameter 'key' cannot be null.");
    else if (key !== undefined) url_ += "key=" + encodeURIComponent("" + key) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_ClearDistributedCache(_response);
      });
  }

  protected processTaxPortal_ClearDistributedCache(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  taxPortal_CreateExternalFolder(
    siteId: number | undefined,
    mDMClientId: number | undefined,
    correlationId: string | undefined,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/CreateExternalFolder?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
    if (mDMClientId === null) throw new Error("The parameter 'mDMClientId' cannot be null.");
    else if (mDMClientId !== undefined) url_ += "MDMClientId=" + encodeURIComponent("" + mDMClientId) + "&";
    if (correlationId === null) throw new Error("The parameter 'correlationId' cannot be null.");
    else if (correlationId !== undefined) url_ += "CorrelationId=" + encodeURIComponent("" + correlationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_CreateExternalFolder(_response);
      });
  }

  protected processTaxPortal_CreateExternalFolder(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  taxPortal_CreateFolderSpecific(
    siteId: number | undefined,
    mDMClientId: number | undefined,
    clientId: number | undefined,
    clientName: string | undefined,
    folderId: string | undefined,
    correlationId: string | undefined,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/CreateFolderSpecific?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
    if (mDMClientId === null) throw new Error("The parameter 'mDMClientId' cannot be null.");
    else if (mDMClientId !== undefined) url_ += "MDMClientId=" + encodeURIComponent("" + mDMClientId) + "&";
    if (clientId === null) throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined) url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
    if (clientName === null) throw new Error("The parameter 'clientName' cannot be null.");
    else if (clientName !== undefined) url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
    if (folderId === null) throw new Error("The parameter 'folderId' cannot be null.");
    else if (folderId !== undefined) url_ += "FolderId=" + encodeURIComponent("" + folderId) + "&";
    if (correlationId === null) throw new Error("The parameter 'correlationId' cannot be null.");
    else if (correlationId !== undefined) url_ += "CorrelationId=" + encodeURIComponent("" + correlationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_CreateFolderSpecific(_response);
      });
  }

  protected processTaxPortal_CreateFolderSpecific(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  taxPortal_SyncConsent(
    clientId: number,
    siteId: number | undefined,
    isMaster: boolean | undefined,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/SyncConsent/{ClientId}?";
    if (clientId === undefined || clientId === null) throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{ClientId}", encodeURIComponent("" + clientId));
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
    if (isMaster === null) throw new Error("The parameter 'isMaster' cannot be null.");
    else if (isMaster !== undefined) url_ += "isMaster=" + encodeURIComponent("" + isMaster) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_SyncConsent(_response);
      });
  }

  protected processTaxPortal_SyncConsent(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  taxPortal_UpdateTaxyear(
    siteId: number | null | undefined,
    clientId: number | null | undefined,
    correlationId: string | undefined,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/UpdateTaxyear?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (clientId !== undefined && clientId !== null) url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
    if (correlationId === null) throw new Error("The parameter 'correlationId' cannot be null.");
    else if (correlationId !== undefined) url_ += "correlationId=" + encodeURIComponent("" + correlationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UpdateTaxyear(_response);
      });
  }

  protected processTaxPortal_UpdateTaxyear(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  taxPortal_SendEmail(
    recipient: string | undefined,
    subject: string | undefined,
    body: string | undefined,
    signal?: AbortSignal
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/SendEmail?";
    if (recipient === null) throw new Error("The parameter 'recipient' cannot be null.");
    else if (recipient !== undefined) url_ += "recipient=" + encodeURIComponent("" + recipient) + "&";
    if (subject === null) throw new Error("The parameter 'subject' cannot be null.");
    else if (subject !== undefined) url_ += "subject=" + encodeURIComponent("" + subject) + "&";
    if (body === null) throw new Error("The parameter 'body' cannot be null.");
    else if (body !== undefined) url_ += "body=" + encodeURIComponent("" + body) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_SendEmail(_response);
      });
  }

  protected processTaxPortal_SendEmail(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  taxPortal_SyncAssignments(signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/SyncAssignments";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_SyncAssignments(_response);
      });
  }

  protected processTaxPortal_SyncAssignments(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  taxPortal_GetClientListBySiteId(
    siteId: number | undefined,
    mDMClientId: number | undefined,
    signal?: AbortSignal
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/GetClientListBySiteId?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
    if (mDMClientId === null) throw new Error("The parameter 'mDMClientId' cannot be null.");
    else if (mDMClientId !== undefined) url_ += "MDMClientId=" + encodeURIComponent("" + mDMClientId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/octet-stream",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetClientListBySiteId(_response);
      });
  }

  protected processTaxPortal_GetClientListBySiteId(response: Response): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  taxPortal_Externaluser(siteId: number | undefined, type: string | undefined, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/ExternalUser?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_Externaluser(_response);
      });
  }

  protected processTaxPortal_Externaluser(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_getUpdateMetaData(siteId: number | undefined, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/updatemetadata?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_getUpdateMetaData(_response);
      });
  }

  protected processTaxPortal_getUpdateMetaData(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_UpdateFolderPermission(siteDetails: ServiceMessage[], signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/UpdateFolderPermission";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteDetails);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UpdateFolderPermission(_response);
      });
  }

  protected processTaxPortal_UpdateFolderPermission(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_CheckSiteConsents(
    siteId: number | undefined,
    clientId: number | undefined,
    signal?: AbortSignal
  ): Promise<GetClientListBySiteIdDTO[]> {
    let url_ = this.baseUrl + "/api/CheckSiteConsents?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (clientId === null) throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined) url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_CheckSiteConsents(_response);
      });
  }

  protected processTaxPortal_CheckSiteConsents(response: Response): Promise<GetClientListBySiteIdDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as GetClientListBySiteIdDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetClientListBySiteIdDTO[]>(null as any);
  }

  taxPortal_UpdateTaxYearInFolderMetaData(siteDetails: ServiceMessage[], signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/UpdateTaxYearInFolderMetaData";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(siteDetails);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UpdateTaxYearInFolderMetaData(_response);
      });
  }

  protected processTaxPortal_UpdateTaxYearInFolderMetaData(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_UpdateIsheetDataTrigger(
    siteId: number | undefined,
    sheetName: string | undefined,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/UpdateIsheetDataTrigger?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (sheetName === null) throw new Error("The parameter 'sheetName' cannot be null.");
    else if (sheetName !== undefined) url_ += "sheetName=" + encodeURIComponent("" + sheetName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_UpdateIsheetDataTrigger(_response);
      });
  }

  protected processTaxPortal_UpdateIsheetDataTrigger(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  taxPortal_GetSiteComments(
    siteId: number | null | undefined,
    api_version: string | null | undefined,
    signal?: AbortSignal
  ): Promise<GetSiteCommentsDTO[]> {
    let url_ = this.baseUrl + "/api/GetSiteComments?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (api_version !== undefined && api_version !== null)
      url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_GetSiteComments(_response);
      });
  }

  protected processTaxPortal_GetSiteComments(response: Response): Promise<GetSiteCommentsDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetSiteCommentsDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetSiteCommentsDTO[]>(null as any);
  }

  taxPortal_AddSiteComments(
    api_version: string | null | undefined,
    site: ServiceMessage,
    signal?: AbortSignal
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/AddSiteComments?";
    if (api_version !== undefined && api_version !== null)
      url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(site);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTaxPortal_AddSiteComments(_response);
      });
  }

  protected processTaxPortal_AddSiteComments(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  usageMetrics_UsageMetrics(signal?: AbortSignal): Promise<SiteReport[]> {
    let url_ = this.baseUrl + "/api/usageMetrics";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUsageMetrics_UsageMetrics(_response);
      });
  }

  protected processUsageMetrics_UsageMetrics(response: Response): Promise<SiteReport[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SiteReport[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SiteReport[]>(null as any);
  }

  usageMetrics_UsageMetricsTest(signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/usageMetricsTest";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUsageMetrics_UsageMetricsTest(_response);
      });
  }

  protected processUsageMetrics_UsageMetricsTest(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  usageMetrics_DownloadUsageMetricFile(fileName: string | undefined, signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/downloadUsageMetricFile?";
    if (fileName === null) throw new Error("The parameter 'fileName' cannot be null.");
    else if (fileName !== undefined) url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUsageMetrics_DownloadUsageMetricFile(_response);
      });
  }

  protected processUsageMetrics_DownloadUsageMetricFile(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  populateISheet_PopulateLegalEntity(message: ServiceMessage, signal?: AbortSignal): Promise<void> {
    let url_ = this.baseUrl + "/api/PopulateLegalEntity";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(message);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateISheet_PopulateLegalEntity(_response);
      });
  }

  protected processPopulateISheet_PopulateLegalEntity(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  populateISheet_SyncISheet(siteId: number | undefined, signal?: AbortSignal): Promise<GetAllRolesDTO[]> {
    let url_ = this.baseUrl + "/api/SyncISheet?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateISheet_SyncISheet(_response);
      });
  }

  protected processPopulateISheet_SyncISheet(response: Response): Promise<GetAllRolesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllRolesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllRolesDTO[]>(null as any);
  }

  populateISheet_CSDefaultISheet(siteId: number | undefined, signal?: AbortSignal): Promise<boolean> {
    let url_ = this.baseUrl + "/api/CSDefaultISheet?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateISheet_CSDefaultISheet(_response);
      });
  }

  protected processPopulateISheet_CSDefaultISheet(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  populateISheet_IRISheetChoices(
    siteId: number | undefined,
    clientId: number | undefined,
    signal?: AbortSignal
  ): Promise<GetAllRolesDTO[]> {
    let url_ = this.baseUrl + "/api/IRISheetChoices?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
    if (clientId === null) throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined) url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateISheet_IRISheetChoices(_response);
      });
  }

  protected processPopulateISheet_IRISheetChoices(response: Response): Promise<GetAllRolesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllRolesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllRolesDTO[]>(null as any);
  }

  populateISheet_DMISheetChoices(
    siteId: number | undefined,
    clientId: number | undefined,
    signal?: AbortSignal
  ): Promise<GetAllRolesDTO[]> {
    let url_ = this.baseUrl + "/api/DMISheetChoices?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
    if (clientId === null) throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined) url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPopulateISheet_DMISheetChoices(_response);
      });
  }

  protected processPopulateISheet_DMISheetChoices(response: Response): Promise<GetAllRolesDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as GetAllRolesDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAllRolesDTO[]>(null as any);
  }

  GetCentralControversyTrackerRecords(
    user: string,
    offset: number,
    limit: number
  ): Promise<CentralControversyTrackerDetailsDTO> {
    let url_ = this.baseUrl + `/api/GetCentralControversyTrackerRecords/{user}/${offset}/${limit}`;
    if (user === undefined || user === null) throw new Error("The parameter 'user' must be defined.");
    if (offset === undefined || offset < 0) throw new Error("The parameter 'offset' must be a non-negative number.");
    if (limit === undefined || limit <= 0)
      throw new Error("The parameter 'limit' must be a positive number greater than 0.");

    url_ = url_.replace("{user}", encodeURIComponent("" + user));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCentralControversyTrackerRecords(_response);
      });
  }

  protected processGetCentralControversyTrackerRecords(
    response: Response
  ): Promise<CentralControversyTrackerDetailsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CentralControversyTrackerDetailsDTO);
        return result200;
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "Request was success but no >Central Controversy Tracker Records was found for user",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Badrequest", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CentralControversyTrackerDetailsDTO>(null as any);
  }

  GetCentralControversyTrackerRecordsBySearch(
    user: string,
    searchTerm: string | null | undefined,
    offset: number,
    limit: number
  ): Promise<CentralControversyTrackerDetailsDTO> {
    if (user === undefined || user === null) throw new Error("The parameter 'user' must be defined.");
    if (searchTerm === undefined) throw new Error("The parameter 'searchTerm' must be defined.");
    if (offset === undefined || offset < 0) throw new Error("The parameter 'offset' must be a non-negative number.");
    if (limit === undefined || limit <= 0)
      throw new Error("The parameter 'limit' must be a positive number greater than 0.");

    let url_ =
      this.baseUrl + `/api/GetCentralControversyTrackerRecordsForGlobalSearch/${user}/${searchTerm}/${offset}/${limit}`;
    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetCentralControversyTrackerRecords(_response);
      });
  }

  GetCentralControversyTrackerUserSites(
    email: string | null | undefined,
    signal?: AbortSignal
  ): Promise<CentralControversyTrackerUserSiteDTO[]> {
    let url_ = this.baseUrl + "/api/GetCentralControversyTrackerUserSites/";
    if (email !== undefined && email !== null) url_ += encodeURIComponent("" + email) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetControversyTrackerUserSites(_response);
      });
  }

  protected processGetControversyTrackerUserSites(response: Response): Promise<CentralControversyTrackerUserSiteDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as CentralControversyTrackerUserSiteDTO[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CentralControversyTrackerUserSiteDTO[]>(null as any);
  }

  userAssignments_GetUsersEntityMapping(
    siteId: number | undefined,
    offset: number | undefined,
    limit: number | undefined,
    signal?: AbortSignal
  ): Promise<UsersEntityMappingsDTO> {
    let url_ = this.baseUrl + "/api/getUsersEntityMapping?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignments_GetUsersEntityMapping(_response);
      });
  }

  protected processUserAssignments_GetUsersEntityMapping(response: Response): Promise<UsersEntityMappingsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UsersEntityMappingsDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UsersEntityMappingsDTO>(null as any);
  }

  userAssignments_GetUsersEntityMappingSearch(
    siteId: number | undefined,
    searchTerm: string | null | undefined,
    signal?: AbortSignal
  ): Promise<UsersEntityMappingsDTO> {
    let url_ = this.baseUrl + "/api/getUsersEntityMappingSearch?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (searchTerm !== undefined && searchTerm !== null)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignments_GetUsersEntityMappingSearch(_response);
      });
  }

  protected processUserAssignments_GetUsersEntityMappingSearch(response: Response): Promise<UsersEntityMappingsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UsersEntityMappingsDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UsersEntityMappingsDTO>(null as any);
  }

  userAssignments_GetUsersEntityHistory(
    siteId: number | undefined,
    offset: number | undefined,
    limit: number | undefined,
    userId: string | undefined,
    signal?: AbortSignal
  ): Promise<UsersEntityMappingsDTO> {
    let url_ = this.baseUrl + "/api/getUsersEntityHistory?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.");
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignments_GetUsersEntityHistory(_response);
      });
  }

  protected processUserAssignments_GetUsersEntityHistory(response: Response): Promise<UsersEntityMappingsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UsersEntityMappingsDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UsersEntityMappingsDTO>(null as any);
  }

  userAssignments_GetUsersEntityHistorySearch(
    siteId: number | undefined,
    searchTerm: string | null | undefined,
    userId: string | undefined,
    signal?: AbortSignal
  ): Promise<UsersEntityMappingsDTO> {
    let url_ = this.baseUrl + "/api/getUsersEntityHistorySearch?";
    if (siteId === null) throw new Error("The parameter 'siteId' cannot be null.");
    else if (siteId !== undefined) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (searchTerm !== undefined && searchTerm !== null)
      url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserAssignments_GetUsersEntityHistorySearch(_response);
      });
  }
  protected processUserAssignments_GetUsersEntityHistorySearch(response: Response): Promise<UsersEntityMappingsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UsersEntityMappingsDTO);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UsersEntityMappingsDTO>(null as any);
  }

  highQ_SyncUsers(signal?: AbortSignal): Promise<string> {
    let url_ = this.baseUrl + "/api/SyncHQUsers?";

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHighQ_SyncUsers(_response);
      });
  }

  protected processHighQ_SyncUsers(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  siteNotification_GetSiteNotificationsForUser(
    siteId: number | null | undefined,
    user: string | null | undefined,
    signal?: AbortSignal
  ): Promise<SiteNotificationDto[]> {
    let url_ = this.baseUrl + "/api/SiteNotification/user?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (user !== undefined && user !== null) url_ += "user=" + encodeURIComponent("" + user) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSiteNotification_GetSiteNotificationsForUser(_response);
      });
  }

  protected processSiteNotification_GetSiteNotificationsForUser(response: Response): Promise<SiteNotificationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === ""
          ? null
          : (JSON.parse(_responseText, this.jsonParseReviver) as SiteNotificationDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SiteNotificationDto[]>(null as any);
  }

  siteNotification_GetAll(
    siteId: number | null | undefined,
    user: string | null | undefined,
    signal?: AbortSignal
  ): Promise<SiteNotificationDto[]> {
    let url_ = this.baseUrl + "/api/SiteNotification?";
    if (siteId !== undefined && siteId !== null) url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
    if (user !== undefined && user !== null) url_ += "user=" + encodeURIComponent("" + user) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSiteNotification_GetAll(_response);
      });
  }

  protected processSiteNotification_GetAll(response: Response): Promise<SiteNotificationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === ""
          ? null
          : (JSON.parse(_responseText, this.jsonParseReviver) as SiteNotificationDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SiteNotificationDto[]>(null as any);
  }

  siteNotification_Create(
    notification: SiteNotificationDto,
    signal?: AbortSignal
  ): Promise<SiteNotificationDto> {
    const url_ = this.baseUrl + "/api/SiteNotification/Create";
    const content_ = JSON.stringify(notification);
    const options_: RequestInit = {
      body: content_,
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => this.http.fetch(url_, transformedOptions_))
      .then((_response: Response) => this.processSiteNotificationMutation(_response));
  }

  siteNotification_Update(
    id: number,
    notification: SiteNotificationDto,
    signal?: AbortSignal
  ): Promise<SiteNotificationDto> {
    const url_ = this.baseUrl + "/api/SiteNotification/Update";
    const content_ = JSON.stringify(notification);
    const options_: RequestInit = {
      body: content_,
      method: "PUT",
      signal,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => this.http.fetch(url_, transformedOptions_))
      .then((_response: Response) => this.processSiteNotificationMutation(_response));
  }

  protected processSiteNotificationMutation(response: Response): Promise<SiteNotificationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 201) {
      return response.text().then((_responseText) =>
        _responseText === "" ? null as any : JSON.parse(_responseText, this.jsonParseReviver) as SiteNotificationDto
      );
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        const result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 201 && status !== 204) {
      return response.text().then((_responseText) =>
        throwException("An unexpected server error occurred.", status, _responseText, _headers)
      );
    }
    return Promise.resolve<SiteNotificationDto>(null as any);
  }
}

export interface SiteNotificationDto {
  id?: number;
  name?: string | undefined;
  siteId?: number | undefined;
  notificationMessage?: string | undefined;
  notificationType?: string | null;
  background?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  isActive?: boolean | undefined;
  createdBy?: string | undefined;
  created?: string | undefined;
  lastModified?: string | undefined;
  lastModifiedBy?: string | undefined;
  associations?: string | undefined;
  roles?: string | undefined;
  
}

export interface CentralControversyTrackerDetailsDTO {
  totalCount?: number;
  offset?: number;
  limit?: number;
  metaData?: CentralControversyTrackerColumns[];
  centralControversyTrackerRecords?: CentralControversyTracker[] | undefined;
}

export interface CentralControversyTrackerColumns {
  columnId?: number;
  columnName?: string;
}

export interface CentralControversyTracker {
  hqSiteId?: number;
  iSheetId?: number;
  siteName?: string | undefined;
  itemId?: number;
  entity?: string | undefined;
  client_Name?: string | undefined;
  tax_Type?: string | undefined;
  matter_Type?: string | undefined;
  description?: string | undefined;
  jurisdiction?: string | undefined;
  authority_Name?: string | undefined;
  resolution_Status?: string | undefined;
  client_Risk?: string | undefined;
  rsM_Responsible_Party?: string | undefined;
  client_Contact_Name?: string | undefined;
  salT_Contact?: string | undefined;
  tfL_Name?: string | undefined;
  responsible_Party_for_Response?: string | undefined;
  estimated_Tax_Amount_Due?: string | undefined;
  estimated_Penalty_Due?: string | undefined;
  estimated_Interest_Due?: string | undefined;
  estimated_Total_Amount_Due?: string | undefined;
  estimated_Total_Amount_Due_Calculated?: string | undefined;
  actual_Tax_Amount_Due?: string | undefined;
  actual_Penalty_Due?: string | undefined;
  actual_Interest_Due?: string | undefined;
  actual_Total_Amount_Due?: string | undefined;
  rsM_Receipt_Date?: string | undefined;
  due_Date_of_Response?: string | undefined;
  date_on_Letter_or_Notice?: string | undefined;
  filing_Period_Start?: string | undefined;
  filing_Period_End?: string | undefined;
  extension_Request_Date?: string | undefined;
  new_Due_Date?: string | undefined;
  clientID_MDM?: string | undefined;
  master_Client_MDM?: string | undefined;
  taxID?: string | undefined;
  notice_ID?: string | undefined;
  jurisdiction_Locality?: string | undefined;
  rsM_Response_Status?: string | undefined;
  rsM_Resolution?: string | undefined;
  notes_to_RSM?: string | undefined;
  attachments?: string | undefined;
  created_by?: string | undefined;
  created_date?: string | undefined;
  modified_by?: string | undefined;
  modified_date?: string | undefined;
  comments?: string | undefined;
  recordTPLink?: string | undefined;
}

export interface CentralControversyTrackerUserSiteDTO {
  siteId: number;
  siteName: string;
}

export interface HighQTemplateSiteISheetComparison {
  siteId?: number;
  isheetToBeAdded?: HQIsheetDBO[] | undefined;
  isheetToBeDeprecated?: HQIsheetDBO[] | undefined;
  isheetToBeCompared?: ISheetCompare[] | undefined;
  isheetRestoreAndToBeCompared?: ISheetCompare[] | undefined;
}

export interface HQIsheetDBO {
  name?: string | undefined;
  id?: number;
}

export interface ISheetCompare {
  templateIsheet?: HQIsheetDBO;
  siteIsheet?: HQIsheetDBO;
}

export interface ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export interface HighQTemplateSiteISheetViewsComparison {
  iSheetViewsToBeAdded?: HQISheetViewDetails[] | undefined;
  templateSiteISheetViewsComparison?: HighQTemplateSiteISheetViews[] | undefined;
}

export interface HQISheetViewDetails {
  iSheetName?: string | undefined;
  iSheetViews?: HQISheetView[] | undefined;
}

export interface HQISheetView {
  viewid?: number | undefined;
  title?: string | undefined;
  markasdefault?: number | undefined;
  emailview?: number | undefined;
  description?: string | undefined;
  allowinlineediting?: string | undefined;
  viewscolumns?: ColumnDetail[];
  viewsortingorder?: SheetViewSortOrder;
  viewfilters?: SheetViewFilter;
}

export interface ColumnDetail {
  columnName?: string | undefined;
  type?: number | undefined;
}

export interface SheetViewSortOrder {
  sortorder?: SheetSortOrder[] | undefined;
}

export interface SheetSortOrder {
  columnName?: string | undefined;
  orderType?: string | undefined;
  sortPosition?: string | undefined;
}

export interface SheetViewFilter {
  row?: SheetRow[] | undefined;
}

export interface SheetRow {
  rowId?: number | undefined;
  columnName?: string | undefined;
  operatorId?: number | undefined;
  oprand?: string | undefined;
  userLookupFilters?: any | undefined;
  logicalType?: string | undefined;
  sheetFilterValueTypeId?: string | undefined;
}

export interface HighQTemplateSiteISheetViews {
  siteISheetId?: number;
  templateISheetId?: number;
  iSheetViewsToBeAdded?: HQISheetView[] | undefined;
  iSheetViewsToBeDeleted?: HQISheetView[] | undefined;
  iSheetViewsToBeCompared?: ISheetViewsCompare[] | undefined;
}

export interface ISheetViewsCompare {
  viewName?: string | undefined;
  templateISheetViewId?: number | undefined;
  siteISheetViewId?: number | undefined;
  markAsDefault?: number | undefined;
  emailView?: number | undefined;
  description?: string | undefined;
  allowInlineEditing?: string | undefined;
  viewColumnsToBeAdded?: ColumnDetails[];
  viewColumnsToBeDeleted?: ColumnDetails[];
  viewColumnsToBeCompared?: ColumnDetails[];
  viewSortOrderOfTemplate?: SheetViewSortOrder;
  viewFiltersOfTemplate?: SheetViewFilter;
}

export interface ColumnDetails extends ColumnDetail {
  index?: number | undefined;
}

export interface HQISheetComparisonDTO {
  iSheetToBeAdded?: HQIsheetDBO[] | undefined;
  iSheetToBeCompared?: ISheetCompare[] | undefined;
}

export interface HighQTemplateSiteNavigationComparison {
  siteId?: number;
  templateId?: number;
  navigationContainersToBeAddedInSite?: HighQNavigationContainersComparisonAdd[] | undefined;
  navigationItemsToBeModifiedInSite?: HighQNavigationItemsComparison | undefined;
  navigationContainersToBeDeprecatedInSite?: HighQNavigationContainersComparisonDeprecate[] | undefined;
}

export interface HighQNavigationContainersComparisonAdd {
  containerToBeAddedInSite?: HQCompareTemplateSiteNavigation | undefined;
  itemsToBeAddedInContainer?: HQCompareTemplateSiteNavigation[] | undefined;
  existingItemsToBeMovedToAddedContainer?: HQCompareTemplateSiteNavigation[] | undefined;
}

export interface HQCompareTemplateSiteNavigation {
  menuid?: number;
  menutypealias?: string;
  contentid?: number;
  contenttypeid?: number;
  contenttypealias?: string;
  siteid?: number;
  parentmenuid?: number;
  parentnameinsite?: string | undefined;
  parentnameintemplate?: string | undefined;
  sheetviewid?: number;
  externalurl?: string | undefined;
  modulealias?: string | undefined;
  menuitemtitles?: NavigationMenuItemTitles;
  itemid?: number;
  numberofcolumns?: number | undefined;
  linktarget?: string | undefined;
  disablelink?: boolean;
  displayorder?: number;
}

export interface NavigationMenuItemTitles {
  menuitemtitle?: NavigationMenuItemTitle[];
}

export interface NavigationMenuItemTitle {
  title?: string | undefined;
  tooltip?: string | undefined;
  language?: string | undefined;
  newtitle?: any | undefined;
}

export interface HighQNavigationItemsComparison {
  newParentItemsToBeAddedInSite?: (HQCompareTemplateSiteNavigation | undefined)[] | undefined;
  newItemsForExistingContainersToBeAddedInSite?: HQCompareTemplateSiteNavigation[] | undefined;
  existingItemsToBeModifiedInSite?: HQCompareTemplateSiteNavigation[] | undefined;
  existingItemsToBeDeprecatedInSite?: HQCompareTemplateSiteNavigation[] | undefined;
}

export interface HighQNavigationContainersComparisonDeprecate {
  containerToBeDeprecatedFromSite?: HQCompareTemplateSiteNavigation | undefined;
  itemsToBeDeprecatedFromContainer?: HQCompareTemplateSiteNavigation[] | undefined;
}

export interface CreateHQISheetViewResponse {
  isheetSuccessViewDetails?: SheetViewDetails[] | undefined;
  isheetFailedViewDetails?: SheetViewDetails[] | undefined;
}

export interface SheetViewDetails {
  isheetId?: number;
  isheetViewsAdded?: ISheetViewAdded[] | undefined;
}

export interface ISheetViewAdded {
  viewid?: number;
  message?: string | undefined;
}

export interface ISheetColumnComparisonResponse {
  siteISheetId?: number;
  columnsToBeAdded?: ColumnDBO[] | undefined;
  columnsToBeDeperecated?: ColumnDBO[] | undefined;
  columnsToBeUpdated?: ISheetColumnUpdate | undefined;
}

export interface ColumnDBO {
  columnid?: number | undefined;
  name?: string | undefined;
  type?: number | undefined;
  status?: number | undefined;
  systemgeneratedtype?: string | undefined;
  section?: number | undefined;
  description?: string | undefined;
  addtodefaultview?: string | undefined;
  columnconditionstate?: string | undefined;
  columnconditions?: ColumnConditionsDBO | undefined;
  columnspecificdetail?: ColumnSpecificDetailDBO | undefined;
  sequence?: string | undefined;
  attributecolumnid?: string | undefined;
  rawdata?: RawDataDBO | undefined;
  colViewPosition?: number | undefined;
  columntype?: string | undefined;
  createdDate?: string | undefined;
  modifiedDate?: string | undefined;
  injectReferenceColumn?: number | undefined;
  parentColumnID?: number | undefined;
  reusecolumnidfromisheet?: number | undefined;
  choicelistid?: number | undefined;
  editpermission?: number | undefined;
  templatesheetcolumnid?: number | undefined;
  uploadpermission?: number | undefined;
  deletepermission?: number | undefined;
  sourceSheetID?: number | undefined;
}

export interface ColumnConditionsDBO {
  row?: FilterRowDBO[] | undefined;
}

export interface FilterRowDBO {
  rowid?: number | undefined;
  columnid?: number | undefined;
  columnname?: string | undefined;
  operatorid?: number | undefined;
  oprand?: string | undefined;
  userlookupfilters?: UserLookupFiltersDBO | undefined;
  logicaltype?: string | undefined;
  sheetfiltervaluetypeid?: string | undefined;
  displaytype?: string | undefined;
  scoreconditiontypeid?: number | undefined;
  sourcecolumnid?: number | undefined;
}

export interface UserLookupFiltersDBO {
  userlookupfilter?: UserLookupFilterDBO[] | undefined;
}

export interface UserLookupFilterDBO {
  oprand?: string | undefined;
  userlookuptype?: string | undefined;
}

export interface ColumnSpecificDetailDBO {
  defaultvalue?: string | undefined;
  columnwidth?: string | undefined;
  sheetname?: string | undefined;
  sitename?: string | undefined;
  mandatory?: string | undefined;
  allowsearch?: string | undefined;
  maxchars?: number | undefined;
  allowfieldfromanotherisheet?: string | undefined;
  allowrichhtmltext?: string | undefined;
  numberoflines?: number | undefined;
  displaymethod?: string | undefined;
  includeotheroption?: string | undefined;
  singleormultileselectioninsearch?: string | undefined;
  choices?: ChoicesDBO | undefined;
  includeinalertpreferences?: string | undefined;
  min?: string | undefined;
  max?: string | undefined;
  decimalplaces?: number | undefined;
  showthousandseparators?: string | undefined;
  showaspercentage?: string | undefined;
  symbolId?: string | undefined;
  numberDecimalFormat?: string | undefined;
  symbolPosition?: string | undefined;
  formattype?: string | undefined;
  dateformat?: string | undefined;
  defaultdateandtime?: string | undefined;
  sheetlookup?: string | undefined;
  fielddisplay?: string | undefined;
  allowmultipleusers?: string | undefined;
  methodtype?: string | undefined;
  sheetids?: string | undefined;
  allowuserstorenamelinks?: string | undefined;
  sheetid?: number | undefined;
  columnids?: string | undefined;
  viewid?: number | undefined;
  allowmultiplevalues?: string | undefined;
  restrictdelete?: string | undefined;
  displaycolumnnameprefix?: string | undefined;
  linkname?: string | undefined;
  donotcountweekendsonlycountmontofri?: string | undefined;
  joinconditions?: JoinConditionsDBO | undefined;
  formula?: string | undefined;
  startvalue?: number | undefined;
  prefix?: string | undefined;
  postfix?: string | undefined;
  minlength?: number | undefined;
  lookupglossarysheetid?: number | undefined;
  lookupglossarysheetviewid?: number | undefined;
  width?: number | undefined;
  otherscorevalue?: string | undefined;
  importdatafromexternalsource?: string | undefined;
  analysisengine?: string | undefined;
  attachmentcustomfolderid?: number | undefined;
  singleLineEmailValidation?: string | undefined;
  readonly?: string | undefined;
  virtualColumn?: number | undefined;
  allowInlineEditing?: string | undefined;
}

export interface ChoicesDBO {
  choice?: ChoiceDBO[] | undefined;
}

export interface ChoiceDBO {
  id?: string | undefined;
  label?: string | undefined;
  score?: string | undefined;
  color?: string | undefined;
  imageid?: number | undefined;
}

export interface JoinConditionsDBO {
  joincondition?: JoinConditionDBO[] | undefined;
}

export interface JoinConditionDBO {
  currentsheetcolumnid?: number | undefined;
  targetsheetcolumnid?: number | undefined;
}

export interface RawDataDBO {
  value?: string | undefined;
  choices?: ChoicesDBO | undefined;
  date?: string | undefined;
  time?: string | undefined;
  linkdisplayname?: string | undefined;
  linkdisplayurl?: string | undefined;
  lookups?: LookupsDBO | undefined;
  folders?: FoldersDBO | undefined;
  documents?: DocumentsDBO | undefined;
  fromdate?: string | undefined;
  todate?: string | undefined;
  attachments?: AttachmentsDBO | undefined;
  isheetitems?: ISheetItemsDBO | undefined;
  dayDifference?: string | undefined;
}

export interface LookupsDBO {
  lookup?: LookupDBO[] | undefined;
}

export interface LookupDBO {
  id?: string | undefined;
  email?: string | undefined;
  userlookuptype?: string | undefined;
}

export interface FoldersDBO {
  folder?: FolderDBO[] | undefined;
}

export interface FolderDBO {
  folderid?: string | undefined;
}

export interface DocumentsDBO {
  document?: DocumentDBO[] | undefined;
}

export interface DocumentDBO {
  docid?: string | undefined;
}

export interface AttachmentsDBO {
  attachment?: AttachmentDBO[] | undefined;
}

export interface AttachmentDBO {
  file?: string | undefined;
  name?: string | undefined;
  order?: string | undefined;
  id?: number | undefined;
  extension?: string | undefined;
  parentfolderid?: number | undefined;
  filehttplink?: string | undefined;
  folderpath?: string | undefined;
  folderhttplink?: string | undefined;
  filesize?: number;
  redactionStatus?: boolean;
  siteid?: number | undefined;
  displayname?: string | undefined;
}

export interface ISheetItemsDBO {
  isheetitem?: ISheetItemDBO[] | undefined;
}

export interface ISheetItemDBO {
  recordid?: string | undefined;
  linkname?: string | undefined;
  apilink?: string | undefined;
  httplink?: string | undefined;
}

export interface ISheetColumnUpdate {
  columnsDataTypeToBeUpdated?: ISheetColumnsDataTypeUpdate[] | undefined;
  columnsPropertiesToBeUpdated?: ColumnDBO[] | undefined;
}

export interface ISheetColumnsDataTypeUpdate {
  templateISheetColumn?: ColumnDBO;
  siteISheetColumn?: ColumnDBO;
}

export interface UpdateSiteISheetColumnNameResponseDTO {
  isheetSiteColumnUpdatedSuccess?: ISheetSiteColumnNamesUpdated[] | undefined;
  isheetSiteColumnUpdatedFailed?: ISheetSiteColumnNamesUpdated[] | undefined;
}

export interface ISheetSiteColumnNamesUpdated {
  columnid?: number | undefined;
  name?: string | undefined;
  message?: string | undefined;
}

export interface UpdateSiteISheetColumnNameRequestDTO {
  siteISheetId?: number;
  isheetSiteColumnNamesTobeUpdated?: HQISheetColumnUpdateDBO[] | undefined;
}

export interface HQISheetColumnUpdateDBO {
  columnid?: number | undefined;
  name?: string | undefined;
  type?: number | undefined;
  status?: number | undefined;
  systemgeneratedtype?: string | undefined;
  section?: number | undefined;
  description?: string | undefined;
  addtodefaultview?: string | undefined;
  columnconditionstate?: string | undefined;
  columnconditions?: ColumnConditionsDBO | undefined;
  columnspecificdetail?: ColumnSpecificDetailDBO | undefined;
  sequence?: string | undefined;
  attributecolumnid?: string | undefined;
  rawdata?: RawDataDBO | undefined;
  colViewPosition?: number | undefined;
  columntype?: string | undefined;
  createdDate?: string | undefined;
  modifiedDate?: string | undefined;
  injectReferenceColumn?: number | undefined;
  parentColumnID?: number | undefined;
  editpermission?: number | undefined;
  templatesheetcolumnid?: number | undefined;
  uploadpermission?: number | undefined;
  deletepermission?: number | undefined;
}

export interface HQTemplateComparisionColumnAddResponse {
  addedColumns?: Columns | undefined;
  failedToAddColumns?: Columns | undefined;
  message?: string | undefined;
}

export interface Columns {
  column?: ColumnResponse[] | undefined;
}

export interface ColumnResponse {
  index?: number | undefined;
  columnid?: number | undefined;
  name?: string | undefined;
  status?: string | undefined;
  statuscode?: string | undefined;
  message?: string | undefined;
  type?: number | undefined;
}

export interface HQISheetColumnAddition {
  columnsToBeAdded?: ColumnDBO[] | undefined;
}

export interface HighQTemplateSiteColPermissionComparisionDTO {
  templateSiteColumnPermissionComparision?: HighQTemplateSiteISheetColumnPermissionComparison[];
  enableColumnsWithISheetPermissions?: EnableColumnsWithISheetPermissions[];
  enableColumnsWithTemplatePermissions?: EnableColumnsWithTemplatePermissions[];
}

export interface HighQTemplateSiteISheetColumnPermissionComparison {
  columnName?: string;
  ispermissionenable?: number;
  columnPermissioToBeAdded?: IsheetcolumnpermissionDTO[] | undefined;
  columnPermissioToBeUpdated?: IsheetcolumnpermissionDTO[] | undefined;
}

export interface IsheetcolumnpermissionDTO {
  gpType?: string;
  name?: string;
  view?: string;
  edit?: string;
}

export interface EnableColumnsWithISheetPermissions {
  columnName?: string;
}

export interface EnableColumnsWithTemplatePermissions {
  columnName?: string;
}

export interface HQUpdateISheetColumnsPropertiesResponse {
  updatedPropertiesForColumns?: HQISheetColumnUpdateDBO[] | undefined;
  failedToUpdatePropertiesForColumns?: HQISheetColumnUpdateDBO[] | undefined;
}

export interface HQISheetPermissionsResponse {
  upddateIsheetPermissionsSuccess?: ISheetDetails[] | undefined;
  upddateIsheetPermissionsFailed?: ISheetDetails[] | undefined;
}

export interface ISheetDetails {
  groupName?: string | undefined;
  message?: string | undefined;
}

export interface GetSiteUpgradeByStatus {
  id?: number | undefined;
  hqSiteId?: number;
  name?: string | undefined;
  mdmMasterClientId?: number;
  mdmClientId?: number;
  orgId?: string | undefined;
  orgName?: string | undefined;
  is7216ConsentReceived?: boolean | undefined;
  templateIdOld?: number | undefined;
  templateNameOld?: string | undefined;
  templateIdNew?: number | undefined;
  templateNameNew?: string | undefined;
  status?: string | undefined;
  message?: string | undefined;
  upgradeDate?: Date | undefined;
  upgradeBy?: string | undefined;
  idUpgradeSiteTracks?: number | undefined;
  siteLastAccessed?: Date | string | undefined;
}

export interface SiteNavigationResponse {
  navigationSuccessResponse?: NavigationSuccessResponse[];
  navigationFailedResponse?: NavigationFailedResponse[];
}

export interface NavigationSuccessResponse {
  aliasType?: string;
  menuTitle?: string;
  successMessage?: string;
}

export interface NavigationFailedResponse {
  aliasType?: string;
  menuTitle?: string;
  failureMessage?: string;
}

export interface SiteFolderPermissionComparisionDTO {
  siteId?: number;
  folderPermissionsComparisions?: FolderPermissionsComparision[];
  enableInheritParentFolderPermissions?: FolderDetails[];
}

export interface FolderPermissionsComparision {
  folderId?: string;
  folderName?: string;
  inherited?: string;
  newGroupPermissionsToBeAdded?: HQSetPermissionsResponse[];
  existingGroupPermissionsToBeUpdated?: HQSetPermissionsResponse[];
}

export interface HQSetPermissionsResponse {
  id?: string;
  name?: string;
  folderpermissions?: Folderpermissions;
  filepermissions?: Filepermissions;
  usergrouptype?: string;
}

export interface Folderpermissions {
  viewfolder?: string;
  viewfiles?: string;
  viewOwn?: string;
  addfiles?: string;
  uploadfiles?: string;
  updatefiles?: string;
  deletefiles?: string;
  admin?: string;
  disableprint?: string;
  disablesave?: string;
  watermark?: string;
}

export interface Filepermissions {
  view?: string;
  viewOwn?: string;
  update?: string;
  delete?: string;
  disableprint?: string;
  disablesave?: string;
  watermark?: string;
}

export interface FolderDetails {
  folderId?: string;
  folderName?: string;
}

export interface HQTemplateSiteGroupComparisionResponse {
  siteGroupsToBeAdded?: SiteGroup[] | undefined;
  siteGroupsToBeUpdated?: SiteGroup[] | undefined;
  systemGroupsToBeAdded?: SiteGroup[] | undefined;
  systemGroupsToBeUpdated?: SiteGroup[] | undefined;
}

export interface SiteGroup {
  name?: string | undefined;
  id?: number;
  type?: string | undefined;
  description?: string | undefined;
  copypermissionsfrom?: Permissions | undefined;
}

export interface Permissions {
  home?: PermissionView | undefined;
  activity?: PermissionView | undefined;
  files?: PermissionView | undefined;
  wiki?: PermissionViewEdit | undefined;
  blog?: PermissionViewEdit | undefined;
  tasks?: PermissionViewEdit | undefined;
  events?: PermissionViewEdit | undefined;
}

export interface PermissionView {
  view?: string | undefined;
}

export interface PermissionViewEdit {
  view?: string | undefined;
  edit?: string | undefined;
}

export interface TemplateSiteMessageResultResponse {
  message?: string | undefined;
  success?: HttpStatusCode;
}

export enum HttpStatusCode {
  Continue = 100,
  SwitchingProtocols = 101,
  Processing = 102,
  EarlyHints = 103,
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NoContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultiStatus = 207,
  AlreadyReported = 208,
  IMUsed = 226,
  MultipleChoices = 300,
  Ambiguous = 300,
  MovedPermanently = 301,
  Moved = 301,
  Found = 302,
  Redirect = 302,
  SeeOther = 303,
  RedirectMethod = 303,
  NotModified = 304,
  UseProxy = 305,
  Unused = 306,
  TemporaryRedirect = 307,
  RedirectKeepVerb = 307,
  PermanentRedirect = 308,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  NotAcceptable = 406,
  ProxyAuthenticationRequired = 407,
  RequestTimeout = 408,
  Conflict = 409,
  Gone = 410,
  LengthRequired = 411,
  PreconditionFailed = 412,
  RequestEntityTooLarge = 413,
  RequestUriTooLong = 414,
  UnsupportedMediaType = 415,
  RequestedRangeNotSatisfiable = 416,
  ExpectationFailed = 417,
  MisdirectedRequest = 421,
  UnprocessableEntity = 422,
  UnprocessableContent = 422,
  Locked = 423,
  FailedDependency = 424,
  UpgradeRequired = 426,
  PreconditionRequired = 428,
  TooManyRequests = 429,
  RequestHeaderFieldsTooLarge = 431,
  UnavailableForLegalReasons = 451,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  HttpVersionNotSupported = 505,
  VariantAlsoNegotiates = 506,
  InsufficientStorage = 507,
  LoopDetected = 508,
  NotExtended = 510,
  NetworkAuthenticationRequired = 511,
}

export interface TemplateSiteComparisonResultDTO {
  siteId?: number;
  siteChanges?: HQSiteChangesDTO[] | undefined;
}

export interface HQSiteChangesDTO {
  comparisonId?: string;
  module?: string;
  upgradeWarning?: string[];
  change?: string;
  object?: string | undefined;
  status?: string | undefined;
  changesDetail?: ChangesDetail[] | undefined;
}

export interface ChangesDetail {
  changeId?: string | undefined;
  change?: string | undefined;
  details?: string[] | undefined;
  partialDetails?: string[];
}

export interface HQTemplateAddGroupResponse {
  siteGroupsAddedSuccess?: SiteSystemGroups[] | undefined;
  siteGroupsAdditionFailed?: SiteSystemGroups[] | undefined;
  systemGroupsAddedSuccess?: SiteSystemGroups[] | undefined;
  systemGroupsAdditionFailed?: SiteSystemGroups[] | undefined;
}

export interface SiteSystemGroups {
  id?: number;
  name?: string | undefined;
  message?: string | undefined;
}

export interface HQTemplateAddGroupRequestDTO {
  siteGroupsToBeAdded?: SiteGroups[] | undefined;
  systemGroupsToBeAdded?: SiteGroups[] | undefined;
}

export interface SiteGroups {
  name?: string | undefined;
  id?: number;
  type?: string | undefined;
  description?: string | undefined;
  copypermissionsfrom?: CopyPermissions | undefined;
}

export interface CopyPermissions {
  home?: CopyPermissionView | undefined;
  activity?: CopyPermissionView | undefined;
  files?: CopyPermissionView | undefined;
  wiki?: CopyPermissionViewEdit | undefined;
  blog?: CopyPermissionViewEdit | undefined;
  tasks?: CopyPermissionViewEdit | undefined;
  events?: CopyPermissionViewEdit | undefined;
}

export interface CopyPermissionView {
  view?: string | undefined;
}

export interface CopyPermissionViewEdit {
  view?: string | undefined;
  edit?: string | undefined;
}

export interface HQTemplateUpdateGroupResponse {
  modulePermissionUpdationSuccess?: HQSiteGroupResponse[];
  modulePermissionUpdationFailure?: HQSiteGroupResponse[];
}

export interface HQSiteGroupResponse {
  groupId?: number;
  name?: string | undefined;
  message?: string | undefined;
}

export interface HQSiteGroupRequestDTO {
  siteGroupsToBeUpdated?: SiteGroups[] | undefined;
  systemGroupsToBeUpdated?: SiteGroups[] | undefined;
}

export interface HQIsheetAdminDBO {
  id?: number;
  title?: string | undefined;
  description?: string | undefined;
  status?: string | undefined;
  accesstype?: string | undefined;
  type?: string | undefined;
  viewlink?: string | undefined;
  allowsections?: string | undefined;
  allowlookup?: string | undefined;
  displayisheet?: string | undefined;
  searchasdefaultview?: string | undefined;
  enableversion?: string | undefined;
  enablesheetalerter?: string | undefined;
  alertercondition?: string | undefined;
  overrideitemmodifieddate?: string | undefined;
  enablebulkinsertupdate?: string | undefined;
  fielddescriptions?: string | undefined;
  enablerowlocking?: string | undefined;
  setcharlimittruncatemultilinetextenabled?: string | undefined;
  setcharlimittruncatemultilinetextval?: string | undefined;
  allowchoicelistvaluesforreuse?: string | undefined;
  allowscorelistvaluesforreuse?: string | undefined;
  allowIsheetComments?: string | undefined;
  shareRecordsLimit?: number;
  shareRecordsLimitEnabled?: number;
  enableIsheetAddRecordFormSharing?: string | undefined;
  allowViewBaseRendering?: string | undefined;
  columns?: HighQISheetColumnsDeatils | undefined;
  recordcount?: string | undefined;
  metadata?: HighQISheetMetadata | undefined;
  head?: HighQISheetHead | undefined;
  data?: HighQISheetData | undefined;
  sheettypeid?: number | undefined;
  enablesmartform?: string | undefined;
  allowDeletedItemsView?: string;
  allowAllColumnsInCustomView?: string;
}

export interface HighQISheetColumnsDeatils {
  column?: ColumnDBO[] | undefined;
}

export interface HighQISheetMetadata {
  viewName?: string | undefined;
  sheetName?: string | undefined;
  siteId?: number;
  siteName?: string | undefined;
  sheetId?: number;
  viewId?: number;
}

export interface HighQISheetHead {
  headColumn?: HighQISheetHeadColumn[] | undefined;
}

export interface HighQISheetHeadColumn {
  sequence?: string | undefined;
  columnId?: string | undefined;
  columnTypeAlias?: string | undefined;
  columnValue?: string | undefined;
  columnTypeId?: string | undefined;
}

export interface HighQISheetData {
  item?: HighQISheetItem[] | undefined;
  column?: HighQISheetColumn[] | undefined;
}

export interface HighQISheetItem {
  itemsequence?: string | undefined;
  itemid?: string | undefined;
  externalid?: string | undefined;
  column?: HighQISheetColumn[] | undefined;
  alerteroption?: string | undefined;
}

export interface HighQISheetColumn {
  columnid?: number;
  name?: string | undefined;
  type?: string | undefined;
  status?: number;
  systemgeneratedtype?: string | undefined;
  section?: number;
  description?: string | undefined;
  addtodefaultview?: string | undefined;
  columnconditionstate?: string | undefined;
  columnconditions?: HighQISheetColumnConditions | undefined;
  columnspecificdetail?: HighQISheetColumnSpecificDetail | undefined;
  sequence?: string | undefined;
  attributecolumnid?: string | undefined;
  rawdata?: HighQISheetRawData | undefined;
  colViewPosition?: number;
  columntype?: string | undefined;
  createdDate?: Date;
  modifiedDate?: Date;
  injectReferenceColumn?: number;
  parentColumnID?: number;
  reusecolumnidfromisheet?: string | undefined;
  choicelistid?: string | undefined;
  editpermission?: number;
  templatesheetcolumnid?: number;
  uploadpermission?: number;
  deletepermission?: number;
  sourceSheetID?: number;
}

export interface HighQISheetColumnConditions {
  row?: HighQISheetRow[] | undefined;
}

export interface HighQISheetRow {
  rowid?: number;
  columnid?: number;
  operatorid?: number;
  oprand?: string | undefined;
  userlookupfilters?: HighQISheetUserLookUpFilters | undefined;
  logicaltype?: string | undefined;
  sheetfiltervaluetypeid?: string | undefined;
  displaytype?: string | undefined;
  scoreConditionTypeid?: number;
  sourceColumnId?: number;
}

export interface HighQISheetUserLookUpFilters {
  userlookupfilter?: HighQISheetUserLookUpFilter[] | undefined;
}

export interface HighQISheetUserLookUpFilter {
  oprand?: string | undefined;
  userlookuptype?: string | undefined;
}

export interface HighQISheetColumnSpecificDetail {
  defaultvalue?: string | undefined;
  columnwidth?: string | undefined;
  sheetname?: string | undefined;
  sitename?: string | undefined;
  mandatory?: string | undefined;
  allowsearch?: string | undefined;
  maxchars?: number;
  allowfieldfromanotherisheet?: string | undefined;
  allowrichhtmltext?: string | undefined;
  numberoflines?: number;
  displaymethod?: string | undefined;
  includeotheroption?: string | undefined;
  singleormultileselectioninsearch?: string | undefined;
  choices?: HighQISheetChoices | undefined;
  includeinalertpreferences?: string | undefined;
  min?: string | undefined;
  max?: string | undefined;
  decimalplaces?: number;
  showthousandseparators?: string | undefined;
  showaspercentage?: string | undefined;
  formattype?: string | undefined;
  dateformat?: string | undefined;
  defaultdateandtime?: string | undefined;
  sheetlookup?: string | undefined;
  fielddisplay?: string | undefined;
  allowmultipleusers?: string | undefined;
  methodtype?: string | undefined;
  sheetids?: string | undefined;
  allowuserstorenamelinks?: string | undefined;
  sheetid?: number;
  columnids?: string | undefined;
  viewid?: number;
  allowmultiplevalues?: string | undefined;
  restrictdelete?: string | undefined;
  displaycolumnnameprefix?: string | undefined;
  linkname?: string | undefined;
  donotcountweekendsonlycountmontofri?: string | undefined;
  joinconditions?: HighQISheetJoinConditions | undefined;
  formula?: string | undefined;
  startvalue?: number;
  prefix?: string | undefined;
  postfix?: string | undefined;
  minlength?: number;
  lookupglossarysheetid?: number;
  lookupglossarysheetviewid?: number;
  width?: number;
  otherscorevalue?: string | undefined;
  importdatafromexternalsource?: string | undefined;
  analysisengine?: string | undefined;
  attachmentcustomfolderid?: number;
  singleLineEmailValidation?: string | undefined;
  readonly?: string | undefined;
  virtualColumn?: number;
  allowInlineEditing?: string | undefined;
}

export interface HighQISheetChoices {
  choice?: HighQISheetChoice[] | undefined;
}

export interface HighQISheetChoice {
  id?: string | undefined;
  apilink?: string | undefined;
  colorStyle?: string | undefined;
  style?: string | undefined;
  label?: string | undefined;
  imageItemID?: string | undefined;
  linkname?: string | undefined;
}

export interface HighQISheetJoinConditions {
  joincondition?: HighQISheetJoinCondition[] | undefined;
}

export interface HighQISheetJoinCondition {
  currentsheetcolumnid?: number;
  targetsheetcolumnid?: number;
}

export interface HighQISheetRawData {
  value?: string | undefined;
  choices?: HighQISheetChoices | undefined;
  date?: string | undefined;
  time?: string | undefined;
  linkdisplayname?: string | undefined;
  linkdisplayurl?: string | undefined;
  lookups?: HighQISheetLookups | undefined;
  folders?: HighQISheetFolders | undefined;
  documents?: HighQISheetDocuments | undefined;
  fromdate?: string | undefined;
  todate?: string;
  attachments?: HighQISheetAttachments | undefined;
  isheetitems?: HighQISheetItems | undefined;
  dayDifference?: string | undefined;
}

export interface HighQISheetLookups {
  lookup?: HighQISheetLookup[] | undefined;
}

export interface HighQISheetLookup {
  id?: string | undefined;
  email?: string | undefined;
  userlookuptype?: string | undefined;
}

export interface HighQISheetFolders {
  folder?: HighQISheetFolder[] | undefined;
}

export interface HighQISheetFolder {
  folderid?: string | undefined;
  foldername?: string | undefined;
  folderPath?: string | undefined;
  httplink?: string | undefined;
  folderindex?: string | undefined;
}

export interface HighQISheetDocuments {
  document?: any | undefined;
}

export interface HighQISheetAttachments {
  attachment?: any | undefined;
}

export interface HighQISheetItems {
  isheetitem?: HighQISheetItem[] | undefined;
}

export interface UpdateFolderPermissionResponse {
  setGroupFolderPermissionsSuccess?: SetGroupFolderPermissionStatus[];
  setGroupFolderPermissionsFailed?: SetGroupFolderPermissionStatus[];
}

export interface SetGroupFolderPermissionStatus {
  groupId?: string;
  groupName?: string;
  message?: string;
}

export interface FolderPermissionUpdateDTO {
  newGroupPermissionsToBeAdded?: HQSetPermissionsResponseDTO[];
  existingGroupPermissionsToBeUpdated?: HQSetPermissionsResponseDTO[];
}

export interface HQSetPermissionsResponseDTO {
  id?: string;
  name?: string;
  folderpermissions?: FolderpermissionsChild;
  filepermissions?: Filepermissions | undefined;
  usergrouptype?: string;
}

export interface FolderpermissionsChild extends Folderpermissions {
  disableprint?: string | undefined;
  watermark?: string | undefined;
}

export interface ChangesAppliedResultResponse {
  siteId?: number;
  siteChanges?: ChangeAppliedResult[] | undefined;
  status?: string;
  upgradeDate?: Date;
}

export interface ChangeAppliedResult {
  comparisonId?: string;
  status?: string;
  modifiedDetail?: ChangesDetail[] | undefined;
}

export interface HighQTemplateSiteViewPermissionComparisionDTO {
  templateSiteViewPermissionComparision?: HighQTemplateSiteISheetViewPermissionComparison[];
}

export interface HighQTemplateSiteISheetViewPermissionComparison {
  viewName?: string;
  viewPermissioToBeAdded?: IsheetviewpermissionDTO[] | undefined;
  viewPermissioToBeUpdated?: IsheetviewpermissionDTO[] | undefined;
}

export interface IsheetviewpermissionDTO {
  name?: string;
  view?: string;
  print?: string;
  export?: string;
  groupType?: string | undefined;
}

export interface AddISheetViewResponseDTO {
  viewAddedSuccessfully?: ISheetViewResponse[];
  failedToAddView?: ISheetViewResponse[];
}

export interface ISheetViewResponse {
  viewId?: number;
  viewName?: string;
  message?: string | undefined;
}

export interface UpdateISheetViewResponseDTO {
  viewUpdatedSuccessfully?: ISheetViewResponse[];
  viewUpdatedPartially?: ISheetViewResponse[];
  failedToUpdateView?: ISheetViewResponse[];
}

export interface UpdateISheetViewRequestDTO {
  iSheetViewsToBeCompared?: ISheetViewsCompare[] | undefined;
}

export interface DeprecateISheetViewResponseDTO {
  viewDeprecatedSuccessfully?: ISheetViewResponse[];
  failedToDeprecateView?: ISheetViewResponse[];
}

export interface ViewPermissionResponse {
  viewPermissionsSuccess?: ViewPermissionStatus[];
  viewPermissionsFailed?: ViewPermissionStatus[];
}

export interface ViewPermissionStatus {
  viewName?: string;
  groupName?: string;
  message?: string;
}

export interface HighQTemplateSiteISheetSectionComparison {
  siteId?: number;
  templateId?: number;
  siteISheetId?: number;
  templateISheetId?: number;
  templateSiteISheetSectionComparison?: HighQTemplateSiteISheetSection[] | undefined;
}

export interface HighQTemplateSiteISheetSection {
  iSheetSectionToBeAdded?: HighQSection[] | undefined;
  iSheetSectionToBeDeleted?: HighQSection[] | undefined;
  iSheetSectionToBeUpdated?: HighQSection[] | undefined;
}

export interface HighQSection {
  id?: number;
  name?: string;
  description?: string;
  sectionAllColumnsNo?: number;
  nonSysGeneratedSectionColumnsNo?: number;
}

export interface HighQTemplateSiteISheetSectionResponse {
  sectionSuccessResponse?: SectionSuccessResponse[];
  sectionFailedResponse?: SectionFailedResponse[];
}

export interface SectionSuccessResponse {
  id?: number;
  name?: string;
  successMessage?: string;
}

export interface SectionFailedResponse {
  id?: number;
  name?: string;
  failureMessage?: string;
}

export interface HQTermsConditionComparison {
  templateId?: number;
  siteId?: number;
  termsandconditions?: number | undefined;
}

export interface HQTermsConditionResponse {
  termsConditionUpdationSuccess?: TermsConditionUpdationDetail | undefined;
  termsConditionUpdationFailed?: TermsConditionUpdationDetail | undefined;
}

export interface TermsConditionUpdationDetail {
  statusCode?: number;
  message?: string | undefined;
}

export interface CEMClientDTO {
  mdmClientId?: number;
  mdmMasterClientId?: number;
  name?: string | undefined;
  countryCode?: string | undefined;
  is7216ConsentReceived?: boolean | undefined;
  year?: number | undefined;
}

export interface CEMUserRecord {
  tpuuid?: string;
  countryCode?: string | undefined;
  cemUserClients?: CEMUserClients[] | undefined;
}

export interface CEMUserClients {
  userId?: string | undefined;
  mdmClientId?: string | undefined;
  userName?: string | undefined;
  siteId?: number | undefined;
}

export interface CEMUserDetails {
  userId?: string | undefined;
  userName?: string | undefined;
}

export interface Task {
  options?: TaskCreationOptions;
  isWaitNotificationEnabledOrNotRanToCompletion?: boolean;
  shouldNotifyDebuggerOfWaitCompletion?: boolean;
  isWaitNotificationEnabled?: boolean;
  id?: number;
  exception?: AggregateException | undefined;
  status?: TaskStatus;
  isCanceled?: boolean;
  isCancellationRequested?: boolean;
  cancellationToken?: CancellationToken;
  isCancellationAcknowledged?: boolean;
  isCompleted?: boolean;
  isCompletedSuccessfully?: boolean;
  creationOptions?: TaskCreationOptions;
  asyncState?: any | undefined;
  executingTaskScheduler?: TaskScheduler | undefined;
  completedEvent?: ManualResetEventSlim;
  exceptionRecorded?: boolean;
  isFaulted?: boolean;
  capturedContext?: ExecutionContext | undefined;
  isExceptionObservedByParent?: boolean;
  isDelegateInvoked?: boolean;
}

export enum TaskCreationOptions {
  None = 0,
  PreferFairness = 1,
  LongRunning = 2,
  AttachedToParent = 4,
  DenyChildAttach = 8,
  HideScheduler = 16,
  RunContinuationsAsynchronously = 64,
}

export interface Exception {
  targetSite?: MethodBase | undefined;
  message?: string;
  data?: any[];
  innerException?: Exception | undefined;
  helpLink?: string | undefined;
  source?: string | undefined;
  hResult?: number;
  stackTrace?: string | undefined;
}

export interface AggregateException extends Exception {
  innerExceptions?: Exception[];
  message?: string;
  innerExceptionCount?: number;
  internalInnerExceptions?: Exception[];
}

export interface MemberInfo {
  memberType?: MemberTypes;
  name?: string;
  declaringType?: string | undefined;
  reflectedType?: string | undefined;
  module?: Module;
  customAttributes?: CustomAttributeData[];
  isCollectible?: boolean;
  metadataToken?: number;
}

export interface MethodBase extends MemberInfo {
  attributes?: MethodAttributes;
  methodImplementationFlags?: MethodImplAttributes;
  callingConvention?: CallingConventions;
  isAbstract?: boolean;
  isConstructor?: boolean;
  isFinal?: boolean;
  isHideBySig?: boolean;
  isSpecialName?: boolean;
  isStatic?: boolean;
  isVirtual?: boolean;
  isAssembly?: boolean;
  isFamily?: boolean;
  isFamilyAndAssembly?: boolean;
  isFamilyOrAssembly?: boolean;
  isPrivate?: boolean;
  isPublic?: boolean;
  isConstructedGenericMethod?: boolean;
  isGenericMethod?: boolean;
  isGenericMethodDefinition?: boolean;
  containsGenericParameters?: boolean;
  methodHandle?: RuntimeMethodHandle;
  isSecurityCritical?: boolean;
  isSecuritySafeCritical?: boolean;
  isSecurityTransparent?: boolean;
}

export enum MethodAttributes {
  PrivateScope = 0,
  ReuseSlot = 0,
  Private = 1,
  FamANDAssem = 2,
  Assembly = 3,
  Family = 4,
  FamORAssem = 5,
  Public = 6,
  MemberAccessMask = 7,
  UnmanagedExport = 8,
  Static = 16,
  Final = 32,
  Virtual = 64,
  HideBySig = 128,
  NewSlot = 256,
  VtableLayoutMask = 256,
  CheckAccessOnOverride = 512,
  Abstract = 1024,
  SpecialName = 2048,
  RTSpecialName = 4096,
  PinvokeImpl = 8192,
  HasSecurity = 16384,
  RequireSecObject = 32768,
  ReservedMask = 53248,
}

export enum MethodImplAttributes {
  IL = 0,
  Managed = 0,
  Native = 1,
  OPTIL = 2,
  CodeTypeMask = 3,
  Runtime = 3,
  ManagedMask = 4,
  Unmanaged = 4,
  NoInlining = 8,
  ForwardRef = 16,
  Synchronized = 32,
  NoOptimization = 64,
  PreserveSig = 128,
  AggressiveInlining = 256,
  AggressiveOptimization = 512,
  InternalCall = 4096,
  MaxMethodImplVal = 65535,
}

export enum CallingConventions {
  Standard = 1,
  VarArgs = 2,
  Any = 3,
  HasThis = 32,
  ExplicitThis = 64,
}

export interface RuntimeMethodHandle {
  value?: IntPtr;
}

export interface IntPtr { }

export enum MemberTypes {
  Constructor = 1,
  Event = 2,
  Field = 4,
  Method = 8,
  Property = 16,
  TypeInfo = 32,
  Custom = 64,
  NestedType = 128,
  All = 191,
}

export interface Module {
  assembly?: Assembly;
  fullyQualifiedName?: string;
  name?: string;
  mdStreamVersion?: number;
  moduleVersionId?: string;
  scopeName?: string;
  moduleHandle?: ModuleHandle;
  customAttributes?: CustomAttributeData[];
  metadataToken?: number;
}

export interface Assembly {
  definedTypes?: TypeInfo[];
  exportedTypes?: string[];
  codeBase?: string | undefined;
  entryPoint?: MethodInfo | undefined;
  fullName?: string | undefined;
  imageRuntimeVersion?: string;
  isDynamic?: boolean;
  location?: string;
  reflectionOnly?: boolean;
  isCollectible?: boolean;
  isFullyTrusted?: boolean;
  customAttributes?: CustomAttributeData[];
  escapedCodeBase?: string;
  manifestModule?: Module;
  modules?: Module[];
  globalAssemblyCache?: boolean;
  hostContext?: number;
  securityRuleSet?: SecurityRuleSet;
}

export interface Anonymous {
  genericTypeParameters?: string[];
  declaredConstructors?: ConstructorInfo[];
  declaredEvents?: EventInfo[];
  declaredFields?: FieldInfo[];
  declaredMembers?: MemberInfo[];
  declaredMethods?: MethodInfo[];
  declaredNestedTypes?: TypeInfo[];
  declaredProperties?: PropertyInfo[];
  implementedInterfaces?: string[];
}

export interface TypeInfo extends Anonymous {
  [key: string]: any;
}

export interface ConstructorInfo extends MethodBase {
  memberType?: MemberTypes;
}

export interface EventInfo extends MemberInfo {
  memberType?: MemberTypes;
  attributes?: EventAttributes;
  isSpecialName?: boolean;
  addMethod?: MethodInfo | undefined;
  removeMethod?: MethodInfo | undefined;
  raiseMethod?: MethodInfo | undefined;
  isMulticast?: boolean;
  eventHandlerType?: string | undefined;
}

export enum EventAttributes {
  None = 0,
  SpecialName = 512,
  RTSpecialName = 1024,
  ReservedMask = 1024,
}

export interface MethodInfo extends MethodBase {
  memberType?: MemberTypes;
  returnParameter?: ParameterInfo;
  returnType?: string;
  returnTypeCustomAttributes?: ICustomAttributeProvider;
  genericParameterCount?: number;
}

export interface ParameterInfo {
  attributes?: ParameterAttributes;
  member?: MemberInfo;
  name?: string | undefined;
  parameterType?: string;
  position?: number;
  isIn?: boolean;
  isLcid?: boolean;
  isOptional?: boolean;
  isOut?: boolean;
  isRetval?: boolean;
  defaultValue?: any | undefined;
  rawDefaultValue?: any | undefined;
  hasDefaultValue?: boolean;
  customAttributes?: CustomAttributeData[];
  metadataToken?: number;
}

export enum ParameterAttributes {
  None = 0,
  In = 1,
  Out = 2,
  Lcid = 4,
  Retval = 8,
  Optional = 16,
  HasDefault = 4096,
  HasFieldMarshal = 8192,
  Reserved3 = 16384,
  Reserved4 = 32768,
  ReservedMask = 61440,
}

export interface CustomAttributeData {
  attributeType?: string;
  constructor?: ConstructorInfo;
  constructorArguments?: CustomAttributeTypedArgument[];
  namedArguments?: CustomAttributeNamedArgument[];
}

export interface CustomAttributeTypedArgument {
  argumentType?: string;
  value?: any | undefined;
}

export interface CustomAttributeNamedArgument {
  argumentType?: string;
  memberInfo?: MemberInfo;
  typedValue?: CustomAttributeTypedArgument;
  memberName?: string;
  isField?: boolean;
}

export interface ICustomAttributeProvider { }

export interface FieldInfo extends MemberInfo {
  memberType?: MemberTypes;
  attributes?: FieldAttributes;
  fieldType?: string;
  isInitOnly?: boolean;
  isLiteral?: boolean;
  isNotSerialized?: boolean;
  isPinvokeImpl?: boolean;
  isSpecialName?: boolean;
  isStatic?: boolean;
  isAssembly?: boolean;
  isFamily?: boolean;
  isFamilyAndAssembly?: boolean;
  isFamilyOrAssembly?: boolean;
  isPrivate?: boolean;
  isPublic?: boolean;
  isSecurityCritical?: boolean;
  isSecuritySafeCritical?: boolean;
  isSecurityTransparent?: boolean;
  fieldHandle?: RuntimeFieldHandle;
}

export enum FieldAttributes {
  PrivateScope = 0,
  Private = 1,
  FamANDAssem = 2,
  Assembly = 3,
  Family = 4,
  FamORAssem = 5,
  Public = 6,
  FieldAccessMask = 7,
  Static = 16,
  InitOnly = 32,
  Literal = 64,
  NotSerialized = 128,
  HasFieldRVA = 256,
  SpecialName = 512,
  RTSpecialName = 1024,
  HasFieldMarshal = 4096,
  PinvokeImpl = 8192,
  HasDefault = 32768,
  ReservedMask = 38144,
}

export interface RuntimeFieldHandle {
  value?: IntPtr;
}

export interface PropertyInfo extends MemberInfo {
  memberType?: MemberTypes;
  propertyType?: string;
  attributes?: PropertyAttributes;
  isSpecialName?: boolean;
  canRead?: boolean;
  canWrite?: boolean;
  getMethod?: MethodInfo | undefined;
  setMethod?: MethodInfo | undefined;
}

export enum PropertyAttributes {
  None = 0,
  SpecialName = 512,
  RTSpecialName = 1024,
  HasDefault = 4096,
  Reserved2 = 8192,
  Reserved3 = 16384,
  Reserved4 = 32768,
  ReservedMask = 62464,
}

export enum SecurityRuleSet {
  None = 0,
  Level1 = 1,
  Level2 = 2,
}

export interface ModuleHandle {
  mdStreamVersion?: number;
}

export enum TaskStatus {
  Created = 0,
  WaitingForActivation = 1,
  WaitingToRun = 2,
  Running = 3,
  WaitingForChildrenToComplete = 4,
  RanToCompletion = 5,
  Canceled = 6,
  Faulted = 7,
}

export interface CancellationToken {
  isCancellationRequested?: boolean;
  canBeCanceled?: boolean;
  waitHandle?: WaitHandle;
}

export interface MarshalByRefObject { }

export interface WaitHandle extends MarshalByRefObject {
  handle?: IntPtr;
  safeWaitHandle?: SafeWaitHandle;
}

export interface CriticalFinalizerObject { }

export interface SafeHandle extends CriticalFinalizerObject {
  ownsHandle?: boolean;
  isClosed?: boolean;
  isInvalid?: boolean;
}

export interface SafeHandleZeroOrMinusOneIsInvalid extends SafeHandle {
  isInvalid?: boolean;
}

export interface SafeWaitHandle extends SafeHandleZeroOrMinusOneIsInvalid { }

export interface TaskScheduler {
  maximumConcurrencyLevel?: number;
  id?: number;
}

export interface ManualResetEventSlim {
  waitHandle?: WaitHandle;
  isSet?: boolean;
  spinCount?: number;
}

export interface ExecutionContext {
  hasChangeNotifications?: boolean;
  isDefault?: boolean;
}

export interface CEMRTAssigmentDTO {
  id?: string | undefined;
  subject?: string | undefined;
  data?: EventData | undefined;
  eventType?: string | undefined;
  dataVersion?: string | undefined;
  metadataVersion?: string | undefined;
  eventTime?: Date | undefined;
  topic?: string | undefined;
}

export interface EventData {
  id?: string | undefined;
  entityType?: string | undefined;
  customProperties?: CustomProperties | undefined;
}

export interface CustomProperties {
  levelType?: string | undefined;
  levelId?: string | undefined;
  userId?: string | undefined;
  applicationId?: string | undefined;
  applicationRoleId?: string | undefined;
  customerId?: string | undefined;
}

export interface MessageResultDTO {
  message?: string | undefined;
  success?: boolean;
}

export interface CustomPowerBiDeleteResponse extends MessageResultDTO {
  noReportFound?: boolean;
  reportFound?: boolean;
  navigationFound?: boolean;
  navigationDeleted?: boolean;
  tableDeleted?: boolean;
}

export interface GetCentralControversyTrackerDetailsDTO {
  metaData?: CentralControversyTrackerColumnsDTO[];
  centralControversyTrackerRecords?: GetCentralControversyTrackerDTO[] | undefined;
}

export interface CentralControversyTrackerColumnsDTO {
  columnId?: number;
  columnName?: string;
}

export interface GetCentralControversyTrackerDTO {
  iSheetId?: number;
  itemId?: number;
  entity?: string | undefined;
  client_Name?: string | undefined;
  tax_Type?: string | undefined;
  matter_Type?: string | undefined;
  description?: string | undefined;
  jurisdiction?: string | undefined;
  authority_Name?: string | undefined;
  resolution_Status?: string | undefined;
  client_Risk?: string | undefined;
  rsM_Responsible_Party?: string | undefined;
  client_Contact_Name?: string | undefined;
  salT_Contact?: string | undefined;
  tfL_Name?: string | undefined;
  responsible_Party_for_Response?: string | undefined;
  estimated_Tax_Amount_Due?: string | undefined;
  estimated_Penalty_Due?: string | undefined;
  estimated_Interest_Due?: string | undefined;
  estimated_Total_Amount_Due?: string | undefined;
  estimated_Total_Amount_Due_Calculated?: string | undefined;
  actual_Tax_Amount_Due?: string | undefined;
  actual_Penalty_Due?: string | undefined;
  actual_Interest_Due?: string | undefined;
  actual_Total_Amount_Due?: string | undefined;
  rsM_Receipt_Date?: string | undefined;
  due_Date_of_Response?: string | undefined;
  date_on_Letter_or_Notice?: string | undefined;
  filing_Period_Start?: string | undefined;
  filing_Period_End?: string | undefined;
  extension_Request_Date?: string | undefined;
  new_Due_Date?: string | undefined;
  clientID_MDM?: string | undefined;
  master_Client_MDM?: string | undefined;
  taxID?: string | undefined;
  notice_ID?: string | undefined;
  jurisdiction_Locality?: string | undefined;
  rsM_Response_Status?: string | undefined;
  rsM_Resolution?: string | undefined;
  notes_to_RSM?: string | undefined;
  attachments?: string | undefined;
  created_by?: string | undefined;
  created_date?: string | undefined;
  modified_by?: string | undefined;
  modified_date?: string | undefined;
  comments?: string | undefined;
}

export interface GetSchedulesDTO {
  id?: number;
  appName?: string | undefined;
  displayName?: string | undefined;
  typeNumber?: number | undefined;
  frequencyType?: string | undefined;
  frequencyValue?: number | undefined;
  status?: string | undefined;
  lastExecutionStatus?: string | undefined;
  scheduledFunction?: string | undefined;
  jobType?: string | undefined;
  lastExecutionDateTime?: Date | undefined;
  nextExecutionDateTime?: Date | undefined;
  startExecution?: Date | undefined;
}

export interface FunctionSchedulerDTO {
  frequencyType?: string | undefined;
  frequencyValue?: number | undefined;
  status?: string | undefined;
  typeNumber?: number | undefined;
  startExecution?: Date | undefined;
}

export interface HQSiteDetailsDTO {
  id?: number | undefined;
  sitename?: string | undefined;
  createddate?: string | undefined;
  sitedescription?: string | undefined;
}

export interface ServiceMessage {
  correlationId?: string | undefined;
  siteId?: number | undefined;
  mdmClientId?: number | undefined;
  isheetId?: number | undefined;
  itemId?: number | undefined;
  year?: number | undefined;
  newTaxYear?: number | undefined;
  isForceUpdate?: boolean | undefined;
  userName?: string | undefined;
  eventType?: ServiceBusEnum;
  roleId?: string | undefined;
  roleName?: string | undefined;
  externalUserType?: string | undefined;
  applicationGroupType?: string | undefined;
  clientName?: string | undefined;
  settingsIds?: number[] | undefined;
  isheetType?: string | undefined;
  appName?: string | undefined;
  processTrackId?: number | undefined;
  scheduleDate?: Date | undefined;
  userOfUserGroupDictionary?: { [key: string]: ResultAllUsersOfUserGroups[] } | undefined;
  userEmailsOfUserGrp?: string[] | undefined;
  usageMetricsType?: string | undefined;
  addResponse?: HQCreateUserRequestDTO[] | undefined;
  removeResponse?: HQCreateUserRequestDTO[] | undefined;
  itemDMFiles?: HQDocumentMetadataRequestDTO[] | undefined;
  fileIds?: string[] | undefined;
  isTriggerFromScheduler?: boolean | undefined;
  siteComments?: string | undefined;
  siteCommentSource?: string | undefined;
}

export interface HQDocumentMetadataRequestDTO {
  entity?: string | undefined;
  pbcStorageLocation?: string | undefined;
  folder?: string | undefined;
  folderPath?: string | undefined;
  file?: string | undefined;
  fileName?: string | undefined;
  itemId?: string | undefined;
  columnId?: string | undefined;
  notes?: string | undefined;
  informationRequestStatus?: string | undefined;
  fileExtension?: string | undefined;
  modifiedBy?: string | undefined;
  modifiedDate?: string | undefined;
  downloaded?: string | undefined;
  uploaded?: string | undefined;
  entityId?: number | undefined;
  copyToImanage?: string | undefined;
  informationRequestId?: string | undefined;
  attachmentId?: string | undefined;
  copyStatus?: string | undefined;
  lockStatus?: string | undefined;
  iManageLink?: string | undefined;
  copiedfromiManage?: string | undefined;
  fileStatus?: string | undefined;
  keepAfterRollover?: string | undefined;
}

export interface SiteCreationMessage extends ServiceMessage {
  status?: string | undefined;
  templateId?: string | undefined;
  templateName?: string | undefined;
  siteName?: string;
  siteConfig?: SiteConfig | undefined;
  isTestSite?: boolean | undefined;
  isProspect?: boolean | undefined;
  isSelectedAllEntity?: boolean | undefined;
  MDMSelectedLegalEntityId?: number[] | undefined;
}

export interface SiteConfig {
  startDate?: Date | undefined;
  endDate?: Date | undefined;
}

export enum ServiceBusEnum {
  SITE_CREATION = 101,
  SYNC_CEM = 102,
  SYNC_CEM_HQ = 103,
  SITE_ADMIN_ACCESS = 104,
  IR_CHOICES = 105,
  EXTERNAL_FOLDER_CREATION = 106,
  SYNC_IR = 107,
  PROVIDE_APP_ACCESS = 108,
  UPDATE_FILES_METADATA = 109,
  UPDATE_FILES_LOCATION = 110,
  DM_CHOICES = 111,
  INTERNAL_FOLDER_CREATION = 112,
  IM_SYNC_RULES = 114,
  CREATE_EXTERNAL_USER = 115,
  SYNC_MDM = 116,
  SYNC_PS = 117,
  DOWNLOAD_FILES = 118,
  DOWNLOAD_ATTACHMENT_IR = 184,
  UPLOAD_FILES = 119,
  UPLOAD_ATTACHMENT_IR = 185,
  UPDATE_IR_METADATA = 120,
  SEND_FILES_TO_DUO = 121,
  IR_ROLLOVER = 122,
  FILES_ROLLOVER = 123,
  SYNC_ISHEET = 124,
  SYNC_CONSENT = 125,
  FOLDER_CREATION_SPECIFIC = 126,
  SYNC_AD = 127,
  SYNC_ENTITY_ISHEET = 128,
  PROVIDE_APP_LEVEL_ACCESS = 129,
  UPDATE_AND_MOVE_FILES = 130,
  SYNC_SITE_SETTINGS = 131,
  CREATE_EXTERNAL_USER_CS = 132,
  REMOVE_EXTERNAL_USER = 133,
  CHECK_EXTERNAL_USER_STATUS = 134,
  IR_ASSIGNED_TO_SEND_EMAIL = 135,
  SYNC_ASSIGNMENT = 136,
  REMOVE_ENTITY_FROM_SITE = 137,
  CREATE_EXTERNAL_USER_THIRD_PARTY = 138,
  ADD_ENTITY_TO_SITE = 139,
  REMOVE_FOLDER_RESTRICTION = 140,
  PUSH_ORG_TO_ISHEET = 141,
  INTERNAL_USER_ASSIGNMENT = 142,
  CS_ISHEET_DEFAULT_DATA = 144,
  REMOVE_SUPPRESSED_ENTITIES = 145,
  PROVIDE_USERGROUP_ACCESS = 146,
  INTERNAL_USER_ASSIGNMENT_CS = 147,
  UPDATE_SHEET_SETTINGS = 148,
  SYNC_CONTROVERSY_TRACKER = 149,
  SITE_CREATION_VERIFY = 150,
  USAGE_METRICS_REPORT = 151,
  TESS_ASSIGNMENT = 152,
  UPDATE_CUSTOM_GROUPS = 155,
  CONTROVERSY_TRACKER = 156,
  GLOBAL_TAX_SYNC = 157,
  TESS_ISHEET_ASSIGNMENT = 158,
  CONTROVERSY_TRACKER_USERS_SYNC = 159,
  MEMBER_FIRM = 161,
  RUN_SITES_API = 162,
  TESS_IUR_ACCESS = 163,
  CONTROVERSY_TRACKER_DELETED_RECORDS_SYNC = 164,
  POPULATE_MEMBERFIRM_DROPDOWN = 165,
  CUSTOM_PERMISSION_PER_ENTITY = 166,
  CUSTOM_PERMISSION_GROUP_CREATION = 167,
  CUSTOM_PERMISSION_GROUP_DELETION = 168,
  SYNC_MDM_PROJECT = 169,
  SYNC_MDM_PHASE = 170,
  SYNC_IMANAGE_WORKSPACE_PER_SITE = 171,
  MDM_SYNC_LEAD_NAMES = 172,
  ROLLOVERS_CS_FILES = 174,
  ROLLOVERS_CS_INFORMATIONREQUEST = 175,
  CUSTOM_VIEW_PERMISSION_PER_ENTITY = 176,
  ROLLOVERS_CS_PROJECTTRACKING = 177,
  CONTROVERSY_TRACKER_LEGACY_RECORD_SYNC = 178,
  UPDATE_K1TRACKER_ENTITY_DROPDOWN = 179,
  UPDATE_DELIVERABLES_ENTITY_DROPDOWN = 180,
  RUN_ISHEET_TRIGGER_API = 181,
  CopyFiles_HighQ_ToImanage = 182,
  UploadFiles_HighQ_ToImanage = 183,
  DOWNLOAD_IR_ATTACHMENT = 184,
  UPLOAD_IR_ATTACHMENT = 185,
  UPDATE_CENTRAL_CONTROVERSY_TRACKER_ENTITIES = 186,
  UPDATE_DOCUMENT_COUNT = 188,
  CONTROVERSY_TRACKER_RECORDS_SYNC = 189,
  SYNC_IDM_USER = 194,
  UPDATE_VIEWS = 154,
  USER_ASSIGNMENT_MICRO_SERVICE = 202,
  ROLLOVERS_DELIVERABLES = 203,
  ROLLOVER_ARCHIVE_CLEANUP = 204,
  ROLLOVER_MICRO_SERVICE = 206,
  SITE_SERVICE_MICRO_SERVICE = 207,
  BULK_SITE_UPGRADE = 208,
  CORPORATE_SIGHT_MICRO_SERVICE = 209,
}

export interface ResultAllUsersOfUserGroups {
  id?: string | undefined;
  name?: string | undefined;
  email?: string | undefined;
  type?: string | undefined;
  hasActiveMembership?: boolean;
}

export interface HQCreateUserRequestDTO {
  itemId?: number | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  action?: string | undefined;
  email?: string | undefined;
  approvedBy?: string | undefined;
  approvedDateTime?: string | undefined;
  registrationStatus?: string | undefined;
  siteAccessStatus?: string | undefined;
  resendStatus?: string | undefined;
  removalStatus?: string | undefined;
  approval?: string | undefined;
  siteName?: string | undefined;
  userGroup?: string | undefined;
  userGroups?: string[];
  organization?: string | undefined;
  role?: string | undefined;
  status?: string | undefined;
  removalDate?: string | undefined;
  insightReportAccess?: string | undefined;
  welcomeEmail?: string | undefined;
  masterClientNumber?: string | undefined;
  clientNameUS?: string | undefined;
  clientNameUSI?: string | undefined;
  assignmentDate?: string | undefined;
  appName?: string | undefined;
}

export interface GetAllSitesFromTrackResponse {
  totalCount?: number;
  data?: GetSiteDBDetails[] | undefined;
}

export interface ItemSyncTrackDto {
  id: number | undefined;
  type: string | undefined;
  hqSiteId: number | undefined;
  status: string | undefined;
  source: string | undefined;
  message: string | undefined;
  subType: string | undefined;
  userName: string | null;
  destination: string | undefined;
  correlationId: string | undefined;
  lastModified: string | undefined;
  lastModifiedBy: string | undefined;
}
export interface GetSiteDatabaseDTO {
  created?: Date | undefined;
  createdBy?: string | undefined;
  lastModified?: Date | undefined;
  lastModifiedBy?: string | undefined;
  hqSiteId?: number | undefined;
  name?: string | undefined;
  status?: string | undefined;
  message?: string | undefined;
  templateName?: string | undefined;
  mdmClientId?: number | undefined;
  orgId?: string | undefined;
  orgName?: string | undefined;
  clientName?: string | undefined;
}

export interface GetSiteDBDetails extends GetSiteDatabaseDTO {
  archivedDate?: Date | undefined;
  archivedBy?: string | undefined;
  restoredDate?: Date | undefined;
  restoredBy?: string | undefined;
}

export interface HQGetChoicesDTO {
  columnid?: number | undefined;
  name?: string | undefined;
  columnspecificdetail?: ColumnspecificdetailDTO | undefined;
}

export interface ColumnspecificdetailDTO {
  choices?: ChoicesDTO | undefined;
}

export interface ChoicesDTO {
  choice?: ChoiceDTO[] | undefined;
}

export interface ChoiceDTO {
  id?: string | undefined;
  label?: string | undefined;
  color?: string | undefined;
}

export interface HQAssignmentDTO {
  projectId?: string | undefined;
  projectName?: string | undefined;
  phaseId?: string | undefined;
  phaseName?: string | undefined;
  entityId?: string | undefined;
  entityName?: string | undefined;
  status?: string | undefined;
  functionalLead?: string | undefined;
  projectLead?: string | undefined;
  delegatedAssignee?: string | undefined;
  preparer?: string | undefined;
  firstReviewer?: string | undefined;
  secondReviewer?: string | undefined;
  clientSignOff?: string | undefined;
  rsmSignOff?: string | undefined;
  tess?: string | undefined;
  dueDate?: Date | undefined;
  transactionId?: string | undefined;
  file?: string | undefined;
}

export interface MDMSelectedLegalEntityDTO {
  countryId?: number | undefined;
  countryName?: string | undefined;
  countryIso?: string | undefined;
  masterClientCountryId?: number | undefined;
  masterClientCountryName?: string | undefined;
  masterClientCountryIso?: string | undefined;
  clientId?: number | undefined;
  clientIdText?: string | undefined;
  clientName?: string | undefined;
  isActive?: boolean | undefined;
  masterClientId?: number | undefined;
  masterClientName?: string | undefined;
  masterClientIdText?: string | undefined;
  hqSiteId?: number | undefined;
  mdmClientId?: number | undefined;
  suppressFolderCreation?: boolean | undefined;
  suppressDropdown?: boolean | undefined;
  suppressProjectStatus?: boolean | undefined;
  userName?: string | undefined;
  isRemoved?: boolean | false;
}

export interface AddMDMSelectedLegalEntityDTO extends MDMSelectedLegalEntityDTO {
  hqClientName?: string | undefined;
  IsTestSite?: boolean | undefined;
  isPDCEnabled?: boolean | undefined;
}

export interface ExternalUserSite {
  id?: number;
  sitename?: string;
  mentiongroups?: number;
  isTaskAttachmentDefault?: number;
  taskAttachmentDefaultFolderId?: number;
}

export interface HQAddItems {
  progressivekey?: string | undefined;
  siteId?: string | undefined;
  sheetId?: string | undefined;
  masterSheetId?: string | undefined;
  status?: string | undefined;
  message?: string | undefined;
  type?: string | undefined;
}

export interface GetAllOrgResponse {
  offset?: number;
  limit?: number;
  totalCount?: number;
  data?: HQOrganizationDTO[] | undefined;
}

export interface HQOrganizationDTO {
  isActive?: boolean;
  created?: Date;
  createdBy?: string;
  lastModified?: Date;
  lastModifiedBy?: string;
  orgId?: number;
  orgName?: string | undefined;
  status?: string | undefined;
  appName?: string | undefined;
}

export interface GetAllSiteMetricResponse {
  offset?: number;
  limit?: number;
  totalCount?: number;
  data?: GetAllSiteMetricsDTO[] | undefined;
}

export interface GetAllSiteMetricsDTO {
  created?: Date;
  createdBy?: string;
  mdmClientId?: number;
  hqSiteId?: number;
  hqClientName?: string | undefined;
  orgId?: string | undefined;
  year?: number | undefined;
  is7216ConsentReceived?: boolean | undefined;
  templateName?: string | undefined;
  country?: string | undefined;
  mdmRegistered?: boolean | undefined;
  capability?: string | undefined;
  region?: string | undefined;
  office?: string | undefined;
}

export interface CEMHQClientMappingDTO {
  id?: number;
  mdmClientId?: number;
  clientName?: string | undefined;
  hqSiteId?: number;
  hqClientName?: string | undefined;
  appName?: string | undefined;
}

export interface CEMHQClientDTO {
  mdmClientId?: number;
  clientName?: string | undefined;
  hqSiteId?: number;
  hqClientName?: string | undefined;
  appName?: string | undefined;
  siteConfig?: string | undefined;
}

export interface DocumentTreeResponseDTO {
  statusCode?: number;
  message?: string;
  data?: DocumentTreeDTO;
}

export interface DocumentTreeDTO {
  siteid?: string | undefined;
  files?: ItemDTO[] | undefined;
}

export interface ItemDTO {
  id?: string | undefined;
  text?: string | undefined;
  icon?: string;
  expanded?: boolean;
  parentId?: string | undefined;
  items?: ItemDTO[];
  itemPath?: string | undefined;
  itemType?: string | undefined;
  disabled?: boolean;
  showMoreLimit?: number;
  level?: number;
  hasItems?: boolean;
  year?: number;
  securitySummary?: string | undefined;
}

export interface MoveFromImanageToHighQResponse {
  success?: boolean;
  message?: string;
  filesForInspection?: MoveFromImanageToHighQRequestObject[] | undefined;
}

export interface MoveFromImanageToHighQRequestObject {
  sourceDocumentId?: string | undefined;
  sourceContainerId?: string | undefined;
  targetParentFolderId?: string | undefined;
  requestId?: number | undefined;
  downloaded?: boolean | undefined;
  fileName?: string;
  overWrite?: boolean | undefined;
  newFileName?: string | undefined;
  isDuplicated?: boolean | undefined;
  documentId?: number | undefined;
  nameWithoutExtension?: string;
}

export interface MoveFromImanageToHighQRequest {
  data?: MoveFromImanageToHighQRequestObject[] | undefined;
  siteId?: number;
  userEmail?: string | undefined;
}

export interface HQWHFile {
  instanceid?: string | undefined;
  instanceBaseUrl?: string | undefined;
  timezone?: string | undefined;
  siteid?: number;
  workflowVersion?: string | undefined;
  workflowid?: number;
  ruleid?: number;
  ruleExecutionTimestamp?: number;
  author?: number;
  triggerDetail?: HQWHFileDetail | undefined;
}

export interface HQWHFileDetail {
  moduleAlias?: string | undefined;
  operation?: string | undefined;
  contentDetail?: HQWHFileContentDetail | undefined;
}

export interface HQWHFileContentDetail {
  contentId?: number;
  parentFolderId?: number;
  documentExtension?: string | undefined;
}

export interface HQWHISheet {
  instanceId?: string | undefined;
  instanceBaseUrl?: string | undefined;
  timeZone?: string | undefined;
  siteId?: number;
  workflowVersion?: string | undefined;
  workflowId?: number;
  ruleId?: number;
  ruleExecutionTimestamp?: number;
  author?: number;
  triggerDetail?: HQWHISheetDetail | undefined;
}

export interface HQWHISheetDetail {
  v1?: V1 | undefined;
}

export interface V1 {
  moduleAlias?: string | undefined;
  operation?: string | undefined;
  contentDetail?: HQWHISheetContentDetail | undefined;
}

export interface HQWHISheetContentDetail {
  contentId?: number;
  isheetId?: number;
  columnIds?: number[];
}

export interface MDMLegalEntityResponse {
  countryCode?: string | undefined;
  legalEntites?: MDMLegalEntityDTO[] | undefined;
  isAllEntitiesSelected?: boolean | false;
}

export interface UsersEntityMappingDTO {
  isActive?: boolean | undefined;
  userId?: string | undefined;
  userName?: string | undefined;
  roleId?: string | undefined;
  roleName?: string | undefined;
  lastActivity?: string | undefined;
  lastActivityDate?: Date;
  entityName?: string | undefined;
}

export interface UsersEntityMappingsDTO {
  offset: number | undefined;
  limit: number | undefined;
  totalCount: number | undefined;
  userEntities: UsersEntityMappingDTO[] | undefined;
}

export interface MDMLegalEntityDTO {
  countryId?: number | undefined;
  countryName?: string | undefined;
  countryIso?: string | undefined;
  masterClientCountryId?: number | undefined;
  masterClientCountryName?: string | undefined;
  masterClientCountryIso?: string | undefined;
  clientId?: number | undefined;
  clientIdText?: string | undefined;
  clientName?: string | undefined;
  isActive?: boolean | undefined;
  masterClientId?: number | undefined;
  masterClientName?: string | undefined;
  masterClientIdText?: string | undefined;
  is7216ConsentReceived?: boolean | undefined;
  consentReceivedYears?: string | undefined;
}

export enum PortalStatusEnum {
  SUCCESS = 101,
  ERROR = 102,
  INFO = 103,
  IR_SYNC_SUCCESS = 104,
  PS_SYNC_SUCCESS = 105,
}

export interface ADTokenDTO {
  token?: string;
  expiresIn?: Date;
}

export enum PowerBIReport {
  TP_PBC_HOMEPAGE = 101,
  TP_PBC_TRACKER = 102,
  TP_PROJECT_STATUS = 103,
  TP_INFORMATION_REQUEST = 104,
  TP_IR_HOME = 105,
  TP_PS_HOME = 106,
  CS_PLANNING_IDEAS = 107,
  CS_PROJECT_TRACKER_LITE = 108,
  CS_GLOBAL_DIRECT = 109,
  CS_US_DIRECT = 110,
  CS_EFILING_TRACKER = 111,
  CS_PROJECT_TRACKER_FULL = 112,
  CS_CASH_TAX = 113,
  SITES_BREAKDOWN = 114,
  GLOBAL_TAX_INFORMATION = 115,
  CONTROVERSY_TRACKER = 116,
  CS_GCVR_DASHBOARD = 117,
  CS_ENHANCED_PROJECT_DASHBOARD = 118
}

export interface EmbeddedReportDTO {
  id?: string | undefined;
  name?: string | undefined;
  embedUrl?: string | undefined;
  token?: string | undefined;
  expiration?: Date;
}

export interface CustomPowerBiResponse {
  hqSiteId: number;
  appName?: string | undefined;
  mdmClientId: number;
  data: CustomPowerBiDTO[];
}
export interface CustomPowerBiDTO {
  customPowerBiID: number;
  powerBIName: string;
  powerBIUrl: string;
  attachments: string;
  primarySME: string;
  alternateSME: string;
  roleAccess?: string[] | string | undefined;
  requester?: string | undefined;
  reportId: string;
  dataSetId: string;
  launchDate: Date;
  isActive: boolean;
  created: Date;
  createdBy: string;
  lastModified: Date;
  lastModifiedBy: string;
  navigationName?: string | undefined;
}

export interface CustomPowerBiRequestDTO {
  hqSiteId: number;
  mdmClientId: number;
  powerBIName: string;
  powerBIUrl: string;
  attachments: string;
  primarySME: string;
  alternateSME: string;
  roleAccess?: string[] | string | undefined;
  requester?: string | undefined;
  reportId: string;
  dataSetId: string;
  launchDate?: Date | undefined;
  isActive?: boolean | undefined;
  navigationName?: string | undefined;
}

export interface ConsolidatedPowerBiReportDTO {
  reportType: number;
  reportTypeName: string;
  reportName: string;
  hqSiteId?: number | undefined;
  clientId?: number | undefined;
  customPowerBiID?: number | undefined;
  appName?: string | undefined;
  fileName?: string | undefined;
  workSpaceId: string;
  reportId: string;
  dataSetId: string;
  roleAccess?: string[] | string | undefined;
}

export interface RolesDTO {
  [key: string]: unknown;
}

export interface GetSiteInfoDTO {
  id?: number | undefined;
  mdmClientId?: number | undefined;
  clientName?: string | undefined;
  hqClientName?: string | undefined;
  appName?: string | undefined;
  siteCreatedBy?: string | undefined;
  siteCreated?: Date | undefined;
  siteLastModified?: Date | undefined;
  siteLastModifiedBy?: string | undefined;
  data?: SiteTrackRecordDTO[] | undefined;
}

export interface SiteTrackRecordDTO {
  trackId?: number | undefined;
  hqSiteId?: number | undefined;
  type?: string | undefined;
  subType?: string | undefined;
  created?: Date | undefined;
  createdBy?: string | undefined;
  lastModified?: Date | undefined;
  lastModifiedBy?: string | undefined;
  status?: string | undefined;
  message?: string | undefined;
  processStarted?: Date | undefined;
  processEnded?: Date | undefined;
}

export interface AddTPSitesDTO {
  mdmClientId?: number;
  clientName?: string | undefined;
  hqSiteId?: number;
  hqSiteName?: string | undefined;
  templateId?: number | undefined;
  templateName?: string | undefined;
  orgId?: number | undefined;
  orgName?: string | undefined;
  year?: number;
  appName?: string | undefined;
}

export interface SiteExtractDetails {
  workSpaces?: WorkspaceDesc[] | undefined;
  phases?: MDMPhaseDesc[] | undefined;
  projects?: MDMProjectDesc[] | undefined;
}

export interface WorkspaceDesc {
  workSpaceId?: string | undefined;
  workspaceName?: string | undefined;
  containerSecurity?: string | undefined;
}

export interface MDMPhaseDesc {
  phaseId?: number;
  phaseName?: string | undefined;
}

export interface MDMProjectDesc {
  projectId?: number;
  projectName?: string | undefined;
}

export interface GetAllSitesResponse {
  offset?: number;
  limit?: number;
  totalCount?: number;
  data?: GetAllSitesInfoDTO[] | undefined;
}

export interface GetAllSitesInfoDTO {
  id?: number | undefined;
  hqSiteId?: number | undefined;
  mdmClientId?: number | undefined;
  clientName?: string | undefined;
  hqClientName?: string | undefined;
  siteCreatedBy?: string | undefined;
  siteCreated?: Date | undefined;
  siteLastModified?: Date | undefined;
  appName?: string | undefined;
  trackId?: number | undefined;
  type?: string | undefined;
  lastModified?: Date | undefined;
  lastModifiedBy?: string | undefined;
  status?: string | undefined;
  message?: string | undefined;
  hasComments?: Boolean | undefined;
}

export enum SyncTypeEnum {
  SYNC_ASSIGNMENT = 101,
  TASK_TEMPLATE = 102,
  IR_CHOICES = 103,
  EXTERNAL_FOLDER_CREATION = 104,
  CREATE_FOLDER_INTERNAL = 105,
  UPDATE_FILES_METADATA = 109,
  UPDATE_FILES_LOCATION = 110,
  DM_CHOICES = 111,
  DOWNLOAD_FILES = 112,
  DOWNLOAD_ATTACHMENT_IR = 184,
  SITE_ADMIN_ACCESS = 113,
  UPLOAD_FILES = 114,
  UPLOAD_ATTACHMENT_IR = 185,
  UPDATE_IR_METADATA = 115,
  SEND_FILES_TO_DUO = 116,
  SYNC_PS = 117,
  SYNC_IR = 118,
  UPDATE_AND_MOVE_FILES = 119,
  ROLLOVER_IR = 122,
  FILES_ROLLOVER = 123,
  SYNC_AD = 127,
  SYNC_ENTITY_ISHEET = 128,
  SYNC_SITE_SETTINGS = 131,
  SYNC_MDM = 132,
  CREATE_EXTERNAL_USER = 133,
  CREATE_EXTERNAL_USER_CS = 134,
  REMOVE_EXTERNAL_USER = 135,
  CHECK_EXTERNAL_USER_STATUS = 136,
  CLIENT_LEVEL_ROLE_ASSIGN = 137,
  CREATE_EXTERNAL_USER_THIRD_PARTY = 138,
  SYNC_CEM = 139,
  SITE_CREATION = 140,
  REMOVE_FOLDER_RESTRICTION = 141,
  PUSH_ORG_TO_ISHEET = 142,
  INTERNAL_USER_ASSIGNMENT = 143,
  CS_ISHEET_DEFAULT_DATA = 144,
  SYNC_ISHEET = 145,
  PROVIDE_USERGROUP_ACCESS = 146,
  INTERNAL_USER_ASSIGNMENT_CS = 147,
  SYNC_CONTROVERSY_TRACKER = 149,
  USAGE_METRICS_REPORT = 151,
  TESS_ASSIGNMENT = 152,
  UPDATE_CUSTOM_GROUPS = 155,
  CONTROVERSY_TRACKER = 156,
  TESS_ISHEET_ASSIGNMENT = 158,
  CONTROVERSY_TRACKER_USERS_SYNC = 159,
  SYNC_CEM_HQ = 160,
  MEMBER_FIRM = 161,
  RUN_SITES_API = 162,
  TESS_IUR_ACCESS = 163,
  CONTROVERSY_TRACKER_DELETED_RECORDS_SYNC = 164,
  POPULATE_MEMBERFIRM_DROPDOWN = 165,
  UPDATE_PI_METADATA = 166,
  CUSTOM_PERMISSION_GROUP_CREATION = 167,
  CUSTOM_PERMISSION_GROUP_DELETION = 168,
  SYNC_MDM_PROJECT = 169,
  SYNC_MDM_PHASE = 170,
  SYNC_IMANAGE_WORKSPACE_PER_SITE = 171,
  MDM_SYNC_LEAD_NAMES = 172,
  ROLLOVERS_CS_FILES = 174,
  ROLLOVERS_CS_INFORMATIONREQUEST = 175,
  ROLLOVERS_CS_PROJECTTRACKING = 177,
  CONTROVERSY_TRACKER_LEGACY_RECORD_SYNC = 178,
  UPDATE_K1TRACKER_ENTITY_DROPDOWN = 179,
  UPDATE_DELIVERABLES_ENTITY_DROPDOWN = 180,
  RUN_ISHEET_TRIGGER_API = 181,
  CopyFiles_HighQ_ToImanage = 182,
  UPLOADFILES_HIGHQ_TOIMANAGE = 183,
  DOWNLOAD_IR_ATTACHMENT = 184,
  UPLOAD_IR_ATTACHMENT = 185,
  UPDATE_CENTRAL_CONTROVERSY_TRACKER_ENTITIES = 186,
  REMOVE_ENTITY_FROM_SITE = 187,
  UPDATE_DOCUMENT_COUNT = 188,
  UPDATE_VIEWS = 154,
  SYNC_INFORMATION_REQUEST_ISHEET = 189,
  SYNC_DOCUMENT_METADATA_ISHEET = 190,
  SYNC_FOLDER_METADATA_ISHEET = 191,
  CONTROVERSY_TRACKER_RECORDS_SYNC = 193,
  SYNC_IDM_USER = 194,
  ROLLOVER_ARCHIVE_CLEANUP = 205,
  SITE_METRICS_IR_RECORD_COUNT = 206,
  SITE_METRICS_PS_RECORD_COUNT = 207,
  SITE_METRICS_NEW_OPPORTUNITIES_RECORD_COUNT = 208,
  SITE_METRICS_K1_TRACKER_RECORD_COUNT = 209,
  SITE_METRICS_CASH_TAX_PAYMENTS_RECORD_COUNT = 210,
  SITE_METRICS_CONTROVERSY_TRACKER_RECORD_COUNT = 211,
  SYNC_DM = 212,
  SYNC_K1_TRACKER = 213,
  SYNC_DELIVERABLES = 214,
  SITE_METRICS_NOTICE_TRACKER_RECORD_COUNT = 215,
  SITE_METRICS_ESTIMATES_TRACKER_RECORD_COUNT = 216,
  SITE_METRICS_ISSUES_TRACKER_RECORD_COUNT = 217,
  SITE_METRICS_DELIVERABLE_LISTING_RECORD_COUNT = 218,
  SITE_METRICS_ENGAGEMENT_OVERVIEW_RECORD_COUNT = 219,
  UPSERT_DUEDATE = 220,
  UPSERT_GLOBAL_DUEDATE = 221,
  UPSERT_SITE_TASKS = 222,
  YEARLY_OIT_EFILE_REPORT = 223,
  GET_OIT_EFILE_RESOURCES = 224,
  UPSERT_ISHEET_ALL_PROJECTS_METADATA = 225,
  UPSERT_ISHEET_ANALYTIC_DATA = 226,
  UPSERT_ISHEET_ANALYTIC_INSIGHT_SETUP = 227,
  UPSERT_ISHEET_RTP_DATA_ANALYTICS = 228,
  UPSERT_ISHEET_TAX_SUMMARY_FORM = 229,
  UPSERT_ISHEET_PLANNING_IDEAS = 230,
  UPSERT_ISHEET_CASH_TAX_PROJECTIONS = 231,
  UPSERT_ISHEET_CASH_TAX_PAYMENTS = 232,
  UPSERT_ISHEET_CASH_TAX_ESTIMATES_TRACKER = 233,
  GET_LIVE_API = 234,
  UPSERT_BINDERS = 235,
  SITE_METRICS_DELIVERABLES_RECORD_COUNT = 237,
  UPDATE_SITE_LAST_ACCESSED = 238,
  ROLLOVER_RETRIEVAL_STORAGE_CLEANUP = 239,
}

export interface GetAllSitesDTO {
  id?: number;
  mdmClientId?: number;
  clientName?: string | undefined;
  hqSiteId?: number;
  hqClientName?: string | undefined;
  created?: Date;
  createdBy?: string;
  lastModified?: Date;
  lastModifiedBy?: string;
  status?: string | undefined;
  message?: string | undefined;
}

export interface MainDTO {
  rows?: RowDTO[] | undefined;
}

export interface RowDTO {
  engagement?: string | undefined;
  project?: string | undefined;
  entity?: string | undefined;
  formName?: string | undefined;
  formNumber?: string | undefined;
  taskTemplate?: string | undefined;
  created?: Date | undefined;
  createdBy?: string | undefined;
  group?: string | undefined;
  itemId?: string | undefined;
  isheetId?: number | undefined;
}

export interface GetSiteHistoryDTO {
  hqSiteId?: number;
  mdmClientId?: number;
  hqClientName?: string | undefined;
  message?: string | undefined;
  updateBy?: string | undefined;
  updateDate?: Date | undefined;
}
export interface GetSiteCommentsDTO {
  hqSiteId?: number | null;
  mdmClientId?: number | null;
  hqClientName?: string | undefined | null;
  siteComments?: string | undefined | null;
  updateBy?: string | undefined | null;
  updateDate?: Date | undefined | null;
  type?: string | undefined | null;
}
export interface HQTaskListResponse {
  list?: TaskList[];
}

export interface TaskList {
  listid?: string;
  parentlistid?: any;
  listname?: string;
  listtype?: string;
  viewid?: string;
}

export interface HQStatusListResponse {
  status?: StatusList[];
}

export interface StatusList {
  statusid?: string;
  statusname?: string;
  statuscolour?: string;
  textstatuscolour?: string;
  statustype?: string;
  alias?: any;
}

export interface AddTask {
  parenttaskid?: number;
  siteid?: string | undefined;
  title?: string | undefined;
  description?: string | undefined;
  duedate?: string | undefined;
  startdate?: string | undefined;
  list?: List | undefined;
  priority?: Priority | undefined;
  status?: Status | undefined;
}

export interface List {
  listid?: string | undefined;
  parentlistid?: string | undefined;
}

export interface Priority {
  priorityid?: string | undefined;
  priorityname?: string | undefined;
}

export interface Status {
  statusid?: string | undefined;
  statusname?: string | undefined;
  statuscolour?: string | undefined;
}

export interface ArchiveSitesDTO {
  siteIds?: number[] | undefined;
  userName?: string | undefined;
}

export interface GetAllRolesDTO {
  name?: string | undefined;
  roleId?: string | undefined;
  userType?: string | undefined;
  displayName?: string | undefined;
}

export interface HQPowerUserRequestDTO {
  powerUser?: string | undefined;
  action?: string | undefined;
  assignmentDate?: string | undefined;
  removalDate?: string | undefined;
  itemId?: number | undefined;
}

export interface RollOverTrackingResponse {
  mdmClientId?: number | undefined;
  rollOverScheduleDays?: number | undefined;
  rollOverLastNotificationDays?: number | undefined;
  hQRolloversTracks?: HQRolloversTrackDTO[] | undefined;
}

export interface HQRolloversTrackDTO {
  isActive?: boolean;
  created?: Date;
  createdBy?: string;
  lastModified?: Date;
  lastModifiedBy?: string;
  id?: number;
  hqSiteId?: number | undefined;
  mdmClientId?: number | undefined;
  rollOverType?: string | undefined;
  rollOverStatus?: string | undefined;
  rollOverStatusMessage?: string | undefined;
  rolloverRequestedDate?: Date | undefined;
  scheduledDate?: Date | undefined;
  canceledDate?: Date | undefined;
  canceledBy?: string | undefined;
  firstNotificationSent?: boolean | undefined;
  secondNotificationSent?: boolean | undefined;
  retryRollOver?: boolean | undefined;
  cancelRollOver?: boolean | undefined;
}

export interface DocumentDetailEntityDTO {
  folderName?: string | undefined;
  folderLink?: string | undefined;
  entity?: string | undefined;
  files?: RolloverFileDTO[] | undefined;
}

export interface RolloverFileDTO {
  fileName?: string;
  fileLink?: string;
}

export interface RolloverInformation {
  rolloverID?: number;
  rolloverinformationList?: HQRolloversTracksDetailDTO[] | undefined;
}

export interface BaseAuditDTO {
  isActive?: boolean;
  created?: Date;
  createdBy?: string;
  lastModified?: Date;
  lastModifiedBy?: string;
  id?: number;
}

export interface HQRolloversTracksDetailDTO extends BaseAuditDTO {
  hqRolloversTracksId?: number;
  hqSiteId?: number | undefined;
  entityId?: number | undefined;
  entityName?: string | undefined;
  step?: string | undefined;
  status?: string | undefined;
  statusMessage?: string | undefined;
}

export interface GetClientListBySiteIdDTO {
  isActive?: boolean | undefined;
  clientId?: number | undefined;
  clientName?: string | undefined;
  mdmClientId?: number | undefined;
  consentReceivedYears?: string | undefined;
  year?: number | undefined;
}

export interface SiteReport {
  isActive?: boolean;
  created?: Date;
  createdBy?: string;
  lastModified?: Date;
  lastModifiedBy?: string;
  id?: number;
  reportType?: string | undefined;
  reportSubType?: string | undefined;
  reportLocation?: string | undefined;
  reportStatus?: string | undefined;
  appName?: string | undefined;
  lastExecutionDateTime?: Date | undefined;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
